export default {
  de: {
    slideshow: "Diashow",
    entry_label_event_plural: "Veranstaltungen",
    entry_label_image_plural: "Medien",
    entry_label_page_plural: "Seiten",
    entry_label_collection_plural: "Sammlungen",
    entry_label_event: "Veranstaltung",
    entry_label_image: "Bild & Kurzvideo",
    entry_label_page: "Seite",
    entry_label_collection: "Sammlung",
    add_an_image: "Bild oder Videoschleife hinzufügen.",
    drag_and_drop: "Datei ziehen und ablegen",
    add_block: "Block hinzufügen",
    add_entries: "Beiträge hinzufügen",
    add_image: "Bild hinzufügen",
    add: "Hinzufügen",
    align: "Ausrichtung",
    align_left: "Linksbündig",
    width_fixed_by_layout: "Breite ist bei diesem Layout festgelegt",
    harmonise_widths: "Breiten angleichen",
    harmonise_widths_hint: "Alle Blöcke dieser Seite auf diese Breite setzen",
    harmonised_widths: "{{count}} Blöcke auf {{width}} gesetzt",
    harmonised_widths_with_skipped: "{{count}} Blöcke auf {{width}} gesetzt, {{skipped}} unverändert gelassen",
    track_inner: "Schmal",
    track_extended_1: "Mittel",
    track_extended_2: "Breit",
    track_flex: "Sehr breit",
    track_full: "Randlos",
    align_center: "Zentriert",
    align_right: "Rechtsbündig",
    all_day: "Ganztägig",
    until: "bis",
    since: "seit",
    all: "Alles",
    articles: "Artikel",
    aspect_ratios: "Seitenverhältnisse",
    avatar: "Avatar",
    back: "Zurück",
    calendar: "Kalender",
    cancel: "Abbrechen",
    close: "Schließen",
    colors: "Farben",
    columns: "Spalten",
    confirm_deletion_of_collection: "Bist du sicher, dass du die Sammlung löschen möchtest?",
    confirm_deletion_of_page: "Bist du sicher, dass du die Seite löschen möchtest?",
    confirm_deletion_of_event: "Bist du sicher, dass du die Veranstaltung löschen möchtest?",
    confirm_deletion_of_series_base_event: "Dies ist der Basistermin einer Serie. Beim Löschen wird der nächste Termin der Serie automatisch zum neuen Basistermin. Bist du sicher?",
    confirm_deletion_of_image: "Bist du sicher, dass du das Bild löschen möchtest?",
    continue: "Fortfahren",
    created_at: "Erstelldatum",
    fill_frame: "Rahmen füllen",
    date_and_time: "Datum und Uhrzeit",
    date: "Datum",
    day: "Tag",
    decimal: "Dezimal",
    decrease: "Verringern",
    delete: "Löschen",
    description: "Beschreibung",
    drop_files_to_upload: "Dateien zum Hochladen ablegen",
    duplicate: "Duplizieren",
    edit: "Bearbeiten",
    email: "E‑Mail-Adresse",
    embed_entries: "Beiträge Einbetten",
    end_date: "Ende",
    equal_size: "Gleiche Größe",
    event: "Veranstaltung",
    events: "Veranstaltungen",
    fields: "Felder",
    filter: "Filter",
    font_family: "Schriftart",
    word_spacing: "Wortabstand",
    font_style: "Schriftstil",
    font_size: "Schriftgröße",
    font_weight: "Schriftfette",
    wght: "Schriftfette",
    opsz: "Optische Größe",
    found_entries: "{{count}} Beiträge gefunden",
    image_alt_label: "Audiobeschreibung für Blinde und Sehbehinderte",
    image_caption_suggestion: "Ergänzende Bildbeschreibung",
    for_example_image_credits: "z.B. Bildnachweis",
    image: "Bild",
    increment: "Erhöhen",
    invalid_file_type: "Ups! Dieser Dateityp wird nicht unterstützt. Bitte wähle eine andere Datei.",
    layout: "Layout",
    layout_group_single_column: "Eine Spalte",
    layout_group_two_column: "Zwei Spalten",
    layout_group_grid: "Raster",
    layout_group_cover: "Titelbild",
    layout_group_bento: "Bento",
    layout_group_editorial: "Redaktionell",
    layout_group_special: "Besonders",
    layout_group_single_column_description: "Einfache einspaltige Layouts",
    layout_group_two_column_description: "Asymmetrische zweispaltige Layouts",
    layout_group_grid_description: "Gleichmäßige Raster mit einstellbarer Spaltenzahl",
    layout_group_cover_description: "Bildschirmfüllendes Bild mit Text darüber",
    layout_group_bento_description: "Asymmetrische Bento-Layouts",
    layout_group_editorial_description: "Layouts im Magazinstil",
    layout_group_special_description: "Besondere, interaktive Layouts",
    legal_name: "Rechtliche Bezeichnung",
    letter_case: "Groß-/Kleinschreibung",
    letter_spacing: "Zeichenabstand",
    limit: "Limit",
    line_height: "Zeilenhöhe",
    link: "Link",
    list: "Liste",
    logout: "Abmelden",
    max: "Max",
    menu: "Menü",
    month: "Monat",
    name: "Name",
    new_entry: "{{entry_type}} erstellen",
    new: "Neu",
    no_entries_found: "Keine Beiträge gefunden",
    none: "Keine",
    page_title: "Seitentitel",
    page: "Seite",
    phone: "Telefon",
    preview: "Vorschau",
    remove: "Entfernen",
    keep: "Behalten",
    replace_image: "Bild ersetzen",
    replace: "Ersetzen",
    role: "Rolle",
    save: "Speichern",
    search_entries: "Beiträge suchen",
    search: "Suchen",
    select_an_option: "Wähle eine Option",
    select_image: "Bild auswählen",
    selected: "Ausgewählt",
    sign_in: "Anmelden",
    sign_up: "Registrieren",
    start_date: "Beginn",
    supported_file_types_are: "Folgende Dateitypen werden unterstützt",
    text: "Text",
    thumbnail_focus: "Schutzzone & Fokus",
    thumbnail: "Vorschaubild",
    title: "Titel",
    this_year: "Dieses Jahr",
    today: "Heute",
    now: "Jetzt",
    /* Heading of the first calendar list section. It holds events starting within the hour AND
       everything currently running, so "Jetzt" reads wrong above a three-month exhibition. */
    currently: "Aktuell",
    typography: "Typographie",
    unknown_error_occured: "Ein unbekannter Fehler is aufgetreten",
    upload_media_hint: "Lade ein hochauflösendes Bild oder Video hoch. Für Bilder: JPEG, PNG, HEIC, HEIF, SVG oder das web-optimierte AVIF Format. Für kurze Videos: WEBP, APNG, MP4 oder WEBM.",
    upload_single_image_hint: "Bild hier ablegen oder zum Hochladen anklicken",
    upload_image: "Bild hochladen",
    optimizing_image: "Bild wird optimiert",
    user: "Benutzer",
    visitor_views: "Besucher",
    warning_delete_aspect_ratio: "Achtung: Beim Löschen des Seitenverhältnis \"{{aspect_ratio}}\" werden alle Blöcke, die derzeit dieses Seitenverhältnis verwenden, auf das Standard-Seitenverhältnis zurückgesetzt. Möchtest du fortfahren?",
    week_number_abbreviation: "KW",
    week: "Woche",
    wide: "Breit",
    width: "Breite",
    position: "Position",
    year: "Jahr",
    learn_more: "Mehr Erfahren",
    insert_url: "URL eingeben",
    control: "Bedienelement",
    analytics: "Analyse",
    show_all_fields: "Alle anzeigen",
    hide_all_fields: "Alle verstecken",
    selection: "Auswahl",
    primary_link_title: "Primärer Link",
    secondary_link_title: "Sekundärer Link",
    add_entry: "Eintrag hinzufügen",
    insert_or_edit_link: "Oder verlinke einen Eintrag",
    entry_previews: "Voransichten von Einträgen",
    links: "Links",
    entries: "Einträge",
    visibility: "Sichtbarkeit",
    selected_entries: "Ausgewählte Beiträge",
    enter_your_email: "Gib deine E‑Mail-Adresse ein.",
    login_code_sent: "Hallo {{name}}, Ein temporärer Anmeldelink wurde an {{email}} gesendet.",
    check_your_email: "Überprüfe deine E-Mail",
    enter_code: "Gib den Code ein",
    login_code_incorrect: "Code ungültig oder abgelaufen. Versuche es erneut.",
    confirm_login_link: "Anmeldung bestätigen",
    confirm_signup_link: "E-Mail-Adresse bestätigen",
    confirm_email_address: "E-Mail-Adresse bestätigen",
    auth_link_invalid: "Dieser Anmeldelink ist ungültig oder abgelaufen.",
    auth_link_recovery: "Fordere einen neuen Link an, um fortzufahren.",
    request_new_auth_link: "Neuen Anmeldelink anfordern",
    signup_code_incorrect: "Registrierungscode ungültig oder abgelaufen. Versuche es erneut.",
    account_blocked_title: "Anmeldung nicht möglich",
    account_blocked_message: "Dieses Konto kann sich derzeit nicht anmelden.",
    account_blocked_message_with_support: "Dieses Konto kann sich derzeit nicht anmelden. Bei Fragen wende dich an {{email}}.",
    rate_limited_message: "Bitte warte eine Minute, bevor du einen neuen Code anforderst.",
    go_back: "Zurück",
    login_code_for: "Anmeldecode für {{domain}}",
    login_code_sent_message:
`<p>Hallo {{receiver}},</p>
<p>Melde dich bei deinem Konto an</p>
<p><a href="{{magic_link_url}}" class="email-cta">Anmelden</a></p>
<p>&nbsp;</p>
<p>Dieser Link und Code sind nur in den nächsten {{expiration_minutes}} Minuten gültig. Wenn der Link nicht funktioniert, kannst du den Login‑Verifizierungscode direkt verwenden:</p>
<p><code class="email-code">{{code}}</code></p>
<p>&nbsp;</p>
<p>Wenn du dies nicht angefordert haben, kannst du diese E‑Mail sicher ignorieren. Bei Problemen antworte uns auf diese E-Mail.</p>
<p>Bis gleich,<br/>{{sender}}</p>`,
    private: "Privat",
    public: "Öffentlich",
    admin: "Admin",
    member: "Mitglied",
    search_users: "Benutzer suchen",
    member_plural: "Mitglieder",
    admin_plural: "Admins",
    users: "Benutzer",
    settings: "Einstellungen",
    edit_user: "Benutzer bearbeiten",
    create_user: "Neuer Benutzer",
    new_user: "Neuer Benutzer",
    signed_in_as: "Angemeldet als",
    grant_member_access_to_new_users: "Neuen Benutzern automatisch die Mitgliederrolle zuweisen",
    accept: "Bestätigen",
    become_a_member: "Mitglied werden",
    signup_code_for: "Registrierungscode für {{domain}}",
    signup_code: "Registrierungscode",
    signup_code_sent: "Wir haben einen Registrierungscode an {{email}} gesendet. Überprüfe deine E‑Mails und klicke auf den Verifizierungslink oder füge den Code unten ein.",
    signup_code_sent_message:
`<p>Hallo,</p>
<p>Vielen Dank für deine Anmeldung! Wir müssen deine E-Mail-Adresse verifizieren, um loslegen zu können.</p>
<p><a href="{{magic_link_url}}" class="email-cta">E-Mail-Adresse verifizieren</a></p>
<p>&nbsp;</p>
<p>Wenn der Link nicht funktioniert, kannst du den Login‑Verifizierungscode direkt kopieren und einfügen:</p>
<p><code class="email-code">{{code}}</code></p>
<p>&nbsp;</p>
<p>Vielen Dank,<br/>{{sender}}</p>`,
    request_login_or_signup_code: "Weiter",
    continue_to_verification: "Weiter zur Verifizierung",  
    admin_info: "Kann Website bearbeiten",
    member_info: "Kann auf Mitglieder-Beiträge zugreifen",
    contact_info: "Kann Nachrichten senden",
    contact: "Kontakt",
    sign_up_or_log_in: "Registrieren oder Anmelden",
    paste_signup_code: "Füge den Registrierungscode hier ein.",
    code_not_received: "Code nicht erhalten? Checke zuerst deinen Spam Ordner. Es kann ein paar Minuten dauern bis der Code ankommt.",
    code_not_received_get_assistance: "Code nicht erhalten? Checke zuerst deinen Spam Ordner. Es kann ein paar Minuten dauern bis der Code ankommt. Für Hilfe schreib uns eine E‑Mail an {{email}}.",
    enter_name: "Vollständiger Name",
    complete_signup: "Registrierung abschließen",
    section: "Abschnitt",
    identity: "Identität",
    announcement: "Ankündigung",
    announcement_enabled: "Ankündigung anzeigen",
    announcement_description: "Die Ankündigung wird oberhalb des Menüs angezeigt und kann von Besuchern geschlossen werden. Nach dem Schließen wird sie für 3 Monate nicht mehr angezeigt, es sei denn, du änderst den Text. Admins sehen die Ankündigung nicht im Editor-Modus. Markdown-Links werden unterstützt, z.B. [Mehr erfahren](/page).",
    announcement_text: "Ankündigung",
    announcement_placeholder: "z.B. Große Eröffnung am 1. März! [Mehr erfahren](/events)",
    footer: "Fußzeile",
    canvas: "Leinwand",
    primary: "Primär",
    secondary: "Sekundär",
    border_radius: "Rahmen Radius",
    nav_items: "Navigations-Einträge",
    menu_placement: "Menü Variante",
    selected_images: "Ausgewählte Bilder",
    collection: "Sammlung",
    save_to_collection: "In Sammlung speichern",
    everyone_on_the_internet: 'Jeder im Internet',
    only_members: 'Nur registrierte Mitglieder',
    just_you: 'Nur du selbst',
    preview_images: "Vorschau Bild",
    selected_preview_images: "Ausgewählte Vorschau Bilder",
    create_collection: 'Neue Sammlung',
    no_collection_found: "Wir konnten keine Sammlungen finden",
    logo: "Logo",
    app_icon: "App-Icon",
    app_icon_must_be_square: "Das Seitenverhältnis des App Icons muss ein Quadrat sein.",
    logo_should_be_svg: "Das Logo sollte eine Vektorgrafik im SVG Dateiformat sein.",
    app_icon_should_be_svg: "Das App Icon sollte eine Vektorgrafik im SVG Dateiformat sein.",
    error: "Fehler",
    sorry_something_went_wrong: "Entschuldigung, etwas ist schief gelaufen.",
    page_not_found_title: "Seite nicht gefunden",
    page_not_found_decription: "Hoppla! Wir konnten die Seite nicht finden. Bitte versuche es später erneut.",
    start_over: "Zurück zur Startseite",
    show_in_mobile_menu: "Im mobilen Menü anzeigen",
    explore: "Entdecken",
    website: "Website",
    block_user: "Benutzer blockieren",
    select_a_block_to_edit: "Wähle einen Block zum Bearbeiten aus",
    my_profile: "Mein Profil",
    enter_your_full_name: "Gib deinen vollständigen Namen ein",
    send_us_a_message_for_account_deletion: `<a class="underline" href="/messages">Schicke uns eine Nachricht</a> wenn du deine E‑Mail-Adresse ändern, oder deinen Account löschen möchtest.`,
    empty_message_prompt: "Hey {{user_name}}! Schön, dass du hier bist. \nTippe deine Nachricht, um zu beginnen.",
    response_input_placeholder: "Antworte hier…",
    search_contacts: "Kontakt suchen",
    no_conversations: "Keine Nachrichten gefunden",
    yesterday: "Gestern",
    new_message_from: "Neue Nachricht von {{sender}} auf {{domain}}",
    new_message_from_member:
      `<p>Hallo {{receiver}}!</p>
      <p>{{sender}} hat gerade eine neue Nachricht auf {{domain}} gesendet.</p>
      <div style="margin:2em 0; border-left: 1px solid currentColor; padding-left: 20px;">{{message_html}}</div>
      <p><a href="{{origin}}/messages?conversation_id={{conversation_id}}" class="email-cta">Im Messenger antworten</a></p>
      <p>Um deine Benachrichtigungseinstellungen zu verwalten, <a href="{{notification_settings_url}}">klicke hier</a>.</p>`,
    new_message_from_admin:
      `<p>Hallo {{receiver}}!</p>
      <p>{{sender}} hat gerade eine neue Nachricht auf {{domain}} gesendet.</p>
      <p><a href="{{origin}}/messages" class="email-cta">Im Messenger antworten</a></p>
      <div style="margin:2em 0; border-left: 1px solid currentColor; padding-left: 20px;">{{message_html}}</div>
      <p><a href="{{origin}}/messages" class="email-cta">Im Messenger antworten</a></p>`,
    you_are_now_a_member_subject: "Du bist jetzt Mitglied von {{domain}}",
    you_are_now_a_member_message:
      `<p>Hallo {{receiver}}!</p>
      <p>Du bist jetzt Mitglied von {{domain}}. Das bedeutet, du kannst z.B. exklusive Inhalte entdecken, die nicht mit der Öffentlichkeit geteilt wurden.</p>
      <p>Bis bald,<br/>{{sender}}</p>`,
    message_us: "Schreib uns",
    messages: "Nachrichten",
    show_all: "Alle anzeigen",
    reset_filters: "Filter zurücksetzen",
    tag_actions: "Tag-Aktionen",
    delete_conversation: "Gespräch löschen",
    select_entry: "Eintrag auswählen",
    select_entries: "{{count}} Einträge auswählen",
    entry: "Eintrag",
    font_size_min: "Minimale Schriftgröße",
    font_size_max: "Maximale Schriftgröße",
    font_slant: "Schriftneigung",
    caption: "Bildunterschrift",
    fill: "Füllung",
    stroke: "Strich",
    preamble: "Vorspann",
    placeholder_preamble: "Vorspann",
    placeholder_title: "Überschrift",
    placeholder_description: "Beschreibung",
    placeholder_primary_link: "Link",
    placeholder_secondary_link: "Zweiter Link",
    home_page: "Startseite",
    select_page: "Seite auswählen",
    change_page: "Seite ändern",
    support_email: "Support-Email",
    support_email_description: "Die Support-E‑Mail wird an den Stellen angezeigt, an denen deine Benutzer ein Problem haben und dich kontaktieren müssen.",
    waiting_for_user_messages: "Alles klar hier! Es gibt noch keine Nachrichten zu sehen. Entspann dich und warte, bis ein Benutzer dir seine erste Nachricht sendet. Bis dahin kannst du dich anderen Aufgaben widmen!",
    website_settings: "Website-Einstellungen",
    account: "Benutzerkonto",
    background: "Hintergrund",
    foreground: "Vordergrund",
    set_as_default: "Als Standard festlegen",
    show_footer: "Fußzeile anzeigen",
    blocked_user_limitations: "Gesperrte Benutzer können sich nicht mehr auf deiner Website anmelden oder registrieren. Sie können jedoch weiterhin öffentliche Inhalte sehen.",
    confirm_make_admin: "Bist du sicher, dass du \"{{name}}\" Admin-Berechtigungen gewähren wollen?",
    cannot_delete_own_account: "Du kannst deinen eigenen Account nicht löschen.",
    confirm_delete_user: "Bist du sicher, dass du \"{{name}}\" unwiderruflich löschen möchtest? Hast du rechtlich relevante Daten manuell gesichert, die einer Aufbewahrungspflicht unterliegen (z.B. eine Angebotsbestätung in einer Nachricht)?",
    all_entries: "Suche",
    no_access_to_all_entries: "Du hast keinen Zugang zu allen Einträgen.",
    access_to_search: "Zugriff für Suche",
    access_level: "Zugriff für \"{{role}}\" und darunter",
    grant_access_level_to: "Zugriffsebene gewähren",
    menu_design: "Menü Design",
    filled_title: "Gefüllt",
    encased_title: "Umschlossen",
    outlined_title: "Umrandet",
    underlined_title: "Unterstrichen",
    frosted_glass_title: "Milchglas",
    beveled_title: "Abgeschrägt",
    gradient_title: "Verlauf",
    ghostly_title: "Durchsichtig",
    elevated_title: "Erhöht",
    select_a_design: "Wähle ein Design aus",
    inline: "Inline",
    control_design_hint: "Wähle das Design für Buttons und Links aus.",
    control_design_title: "Buttons und Links",
    weblink: "Weblink",
    on_this_page: "Auf dieser Seite",
    separator: "Trennung",
    spacer: "Weißraum",
    spacing: "Abstand",
    search_layouts: "Layout suchen",
    properties: "Eigenschaften",
    link_to_full_entries: "Verlinke Beiträge",
    updated_at: "Aktualisiert am",
    exit: "Beenden",
    confirm_delete_selected_entries: "Bist du sicher, dass du diese {{count}} Einträge löschen wollen? Du kannst diese nicht mehr rückgängig machen.",
    selected_entries_count: "{{count}} {{type}} ausgewählt",
    clear_filters: "Filter zurücksetzen",
    page_settings: "Seiteneinstellungen",
    no_collections_create_your_first: "Keine Sammlungen vorhanden. Erstelle deine erste Sammlung.",
    enter_collection_title: "Gib deiner Sammlung einen Titel.",
    new_collection: "Neue Sammlung",
    my_collections: "Meine Sammlungen",
    signup_or_login_text_label: "Text für Anmeldeseite",
    signup_or_login_text_description: "Dieser Text wird auf der Anmeldeseite angezeigt. Wir empfehlen, einen Link zu deiner Datenschutzrichtlinie und Nutzungsbedingungen hinzuzufügen.",
    block_spacing_factor: "Block Abstandsfaktor",
    page_inline_spacing: "Seitenabstand",
    select_max_size: "Maximalgröße auswählen",
    grid_gutter: "Grid Abstand",
    select_min_size: "Minimalgröße auswählen",
    animation_intensity: "Intensität von Animationen",
    animation_intensity_description: "Die Intensität der Animationen auf der Website. 0 bedeutet keine Animationen, 1 bedeutet volle Animationen.",
    select_available_layouts_for_viewers: "Wähle verfügbare Layouts für Besucher aus",
    three_column_grid: "3 Spalten Raster",
    four_column_grid: "4 Spalten Raster",
    page_design: "Seitendesign",
    collection_layouts: "Sammlung Layouts",
    publish: "Veröffentlichen",
    docked_s: "Angedockt S",
    docked_m: "Angedockt M",
    docked_l: "Angedockt L",
    floating_s: "Schwebend S",
    floating_m: "Schwebend M",
    floating_l: "Schwebend L",
    send: "Senden",
    next: "Nächste",
    previous: "Vorherige",
    find_entries: "Einträge finden",
    elevation: "Emporheben",
    mobile_alignment: "Ausrichtung (mobil)",
    text_style: "Textstil",
    user_profile: "Benutzerprofil",
    access_to_user_profiles: "Zugriff auf Benutzerprofile",
    access_to_user_profiles_description: "Wähle die Mindestzugriffsebene für Benutzerprofile aus. Diese Einstellung gilt für alle Benutzerprofile auf der Website. Sie ermöglicht es z.B. die Kollektionen anderer Benutzer zu sehen.",
    access_to_search_description: "Wähle die Mindestzugriffsebene für die Suche aus. Diese Einstellung gilt für alle Benutzer auf der Website. Wenn Zugriffsebene \"Öffentlich\" gewählt wird, kann jeder Besucher alle öffentlichen Einträge suchen.",
    no_collections_hint: "Keine Sammlungen vorhanden. Suche nach Inhalten, die dir gefallen, und füge sie deiner Sammlung hinzu, indem du auf das Lesezeichen-Symbol im Menü oben rechts klickst.",
    add_entries_to_collection: "Einträge zu Sammlung hinzufügen",
    sign_in_and_send_message: "Anmelden und Nachricht senden",
    messages_title: "Messenger Überschrift",
    messages_intro: "Messenger Intro",
    event_reminder_emails_enabled: "Erinnerungs-E-Mails für Veranstaltungen",
    event_reminder_emails_enabled_description: "Wenn aktiviert, werden automatische Erinnerungs-E-Mails für bevorstehende Veranstaltungen versendet.",
    send_us_a_message: "Schick uns eine Nachricht",
    use_our_messenger_to_contact_us: "Du kannst uns direkt über unseren Messenger kontaktieren.",
    button: "Button",
    read_more: "Weiter lesen",
    button_label: "Button Beschriftung",
    images: "Bilder",
    footer_color: "Fußzeile Farbe",
    create: "Erstellen",
    add_nav_item: "Menüeintrag hinzufügen",
    mobile_menu_breakpoint: "Umbruchpunkt (mobil)",
    image_zoom: "Bildvergrößerung",
    image_zoom_setting_description: "Erlaube es den Benutzern, Bilder in eine Vollbildansicht zu vergrößern.",
    no_collection_entries_hint: "Deine Sammlung ist leer. Durchstöbere die Website und füge Inhalte über das Menü oben rechts zu deiner Sammlung hinzu.",
    empty_collection: "Leere Sammlung",
    new_user_registered: "Der Benutzer {{email}} hat sich gerade auf {{domain}} registriert",
    new_user_registered_message:
      `<p>Hello {{receiver}}!</p>
      <p>{{email}} hat sich gerade auf {{domain}} registriert.</p>
      <table style="width: 100%; max-width: 600px; margin: 20px 0; border-collapse: collapse; font-family: inherit;">
        <tbody>
          <tr style="background-color: rgba(0,0,0,0.02);">
            <td style="padding: 12px; border: 1px solid rgba(0,0,0,0.1); font-weight: 600;">E‑Mail</td>
            <td style="padding: 12px; border: 1px solid rgba(0,0,0,0.1);">{{email}}</td>
          </tr>
          <tr>
            <td style="padding: 12px; border: 1px solid rgba(0,0,0,0.1); font-weight: 600;">Name</td>
            <td style="padding: 12px; border: 1px solid rgba(0,0,0,0.1);">{{name}}</td>
          </tr>
          <tr style="background-color: rgba(0,0,0,0.02);">
            <td style="padding: 12px; border: 1px solid rgba(0,0,0,0.1); font-weight: 600;">Rolle</td>
            <td style="padding: 12px; border: 1px solid rgba(0,0,0,0.1);">{{role}}</td>
          </tr>
          <tr>
            <td style="padding: 12px; border: 1px solid rgba(0,0,0,0.1); font-weight: 600;">Registriert</td>
            <td style="padding: 12px; border: 1px solid rgba(0,0,0,0.1);">{{created_at}}</td>
          </tr>{{custom_fields_rows}}
        </tbody>
      </table>
      <p>Du kannst die Benutzerdaten <a href="{{origin}}/users">hier</a> überprüfen.</p>
      <p>Du kannst dort auch steuern welche Rolle (Admin, Mitglied, Kontakt) dieser Benutzer haben soll.</p>
      <p>Sollte die Person nicht vertrauenswürdig erscheinen (z.B. ein Spambot), kannst du die Person auch blocken. Dadurch wird auch verhindert, dass diese sich erneut mit dieser E‑Mail-Adresse registriert.</p>
      <p>Um deine Benachrichtigungseinstellungen zu verwalten, <a href="{{notification_settings_url}}">klicke hier</a>.</p>`,
    enquire_about_collection: "Anfrage zur Sammlung",
    collection_message_enquire_subject: "Anfrage zu Sammlung:",
    to_view_full_collection_become_member: "Um die gesamte Sammlung zu sehen, werde Mitglied.",
    default_member_created_collection_entry_visibility: "Standard Sichtbarkeit für Sammlungen von Mitgliedern",
    default_member_created_collection_entry_visibility_description: "Diese Einstellung gilt für alle Sammlungen, die Mitglieder erstellen. Sie legt fest, welche Sichtbarkeit Sammlungen haben, wenn sie erstellt werden.",
    set_default_visibility: "Standard Sichtbarkeit festlegen",
    public_description: "Für alle sichtbar",
    member_description: "Sichtbar für registrierte Mitglieder",
    private_description: "Nur für dich sichtbar",
    account_settings: "Benutzerkonto",
    switch_account: "Konto wechseln",
    notification_preferences: "Benachrichtigungen",
    receive_signup_notifications: "Registrierungsmails erhalten",
    receive_message_notifications: "Nachrichtenmails erhalten",
    team_access: "Team Zugriff", 
    team_access_intro: "Erlaube vertrauenswürdigen Teammitgliedern, in deinem Namen zu handeln. \nTeammitglieder können:",
    team_permissions_posts: "Deine öffentlichen und privaten Beiträge ansehen und bearbeiten.",
    team_permissions_bookings: "Buchungen mit deinem Konto vornehmen.",
    team_permissions_messages: "Auf deine Nachrichten zugreifen.",
    team_access_revoke_anytime: "Du kannst den Team-Zugriff jederzeit widerrufen.",
    team_access_limitations: "Teammitglieder können deine Kontoeinstellungen nicht einsehen oder ändern.",
    team_member_email: "E‑Mail des Teammitglieds",
    enter_team_member_email: "E‑Mail-Adresse deines Teammitglieds",
    add_team_member: "Teammitglied hinzufügen",
    invalid_email_provided: "Ungültige E‑Mail-Adresse.",
    user_not_found: "Benutzer nicht gefunden.",
    cannot_add_self_as_team_member: "Du kannst dich nicht selbst als Teammitglied hinzufügen.",
    user_already_team_member: "Dieser Benutzer ist bereits ein Teammitglied.",
    change: "Ändern",
    allow_enquiry: "Erlaube Anfragen",
    optional_link: "Optionaler Link",
    show_more: "Details anzeigen",
    posters: "Posters",
    url: "URL",
    your_account: "Dein Account",
    change_image: "Bild ändern",
    profile_picture: "Profilbild",
    delete_account: "Account löschen",
    webhooks: "Webhooks",
    webhook_url: "Webhook URL",
    webhook_url_placeholder: "https://hooks.zapier.com/hooks/catch/... oder /api/webhooks/example-service",
    webhook_url_description: "Die URL, an die Webhook-Benachrichtigungen gesendet werden. Funktioniert mit Zapier, Make.com, n8n oder deinem eigenen Server.",
    webhook_enabled: "Webhooks aktivieren",
    webhook_events: "Ereignisse",
    webhook_events_description: "Wähle, welche Ereignisse einen Webhook auslösen sollen.",
    webhook_event_user_signup: "Benutzerregistrierung",
    webhook_event_user_signin: "Benutzeranmeldung",
    webhook_event_user_update: "Benutzeraktualisierung",
    webhook_event_registration_new: "Neue Veranstaltungsanmeldung",
    webhook_event_registration_update: "Veranstaltungsanmeldung aktualisiert",
    webhook_event_registration_cancel: "Veranstaltungsanmeldung storniert",
    webhook_preview: "Webhook-Vorschau",
    webhook_preview_description: "Sieh dir ein Beispiel der Daten an, die gesendet werden, wenn dieses Ereignis ausgelöst wird.",
    webhook_secret_info: "Webhook-Signatur",
    webhook_secret_description: "Alle Webhooks werden mit einem HMAC SHA-256-Signaturheader (X-Webhook-Signature) signiert. Verwende den WEBHOOK_SECRET aus deiner .env-Datei, um die Signatur zu überprüfen.",
    webhook_security_note: "Hinweis: Das Webhook-Secret wird serverseitig in deinen Umgebungsvariablen (env-Datei) gespeichert.",
    webhook_secret_not_configured: "Webhooks können nicht aktiviert werden, da kein WEBHOOK_SECRET in den Umgebungsvariablen (env-Datei) gesetzt ist. Bitte füge WEBHOOK_SECRET zu deiner .env-Datei hinzu.",
    style: "Stil",
    color: "Farbe",
    new_poster: "Neues Poster",
    pin: "Anheften",
    unpin: "Loslösen",
    pinned: "Angeheftet",
    registrations: "Registrierungen",
    view_registrations: "Registrierungen anzeigen",
    my_registrations: "Meine Registrierungen",
    my_registration: "Meine Registrierung",
    register_for_event: "Für Veranstaltung registrieren",
    existing_reservations: "Bestehende Reservierungen",
    new_registrations: "Neue Registrierungen",
    guest_numbered: "Gast {{number}}",
    delete_registration: "Registrierung löschen",
    manage_registrations: "Registrierungen verwalten",
    update_registrations: "Registrierungen aktualisieren",
    register_now: "Jetzt anmelden",
    confirm_registration: "Registrierung bestätigen",
    register: "Registrieren",
    guest: "Gast",
    full_name: "Vollständiger Name",
    max_attendees: "Maximale Teilnehmerzahl",
    max_guests_per_registration: "Maximale Gäste pro Registrierung",
    for_example_location: "Untertitel (z.B. Ort)",
    event_registrations_update_error: "Fehler beim Aktualisieren der Registrierungen",
    event_not_found: "Veranstaltung nicht gefunden.",
    discard_changes_confirmation: "Du hast ungespeicherte Änderungen. Bist du sicher, dass du sie verwerfen möchtest?",
    registration_not_available: "Keine Registrierung möglich",
    event_has_concluded: "Die Veranstaltung ist vergangen",
    event_is_booked_out: "Die Veranstaltung ist ausgebucht",
    event_reminder_subject: "Erinnerung: {{title}} morgen", 
    event_reminder_intro: "Wir möchten dich an die Veranstaltung für die du morgen registriert bist, erinnern:",
    event_reminder_footer: "Wir freuen uns auf deinen Besuch!",  
    number_of_guests: "Anzahl der Gäste",
    add_guest: "Gast hinzufügen",
    registrations_updated: "Registrierungen aktualisiert",
    registration_toast_created_singular: "Registrierung erstellt.",
    registration_toast_created_plural: "Registrierungen erstellt.",
    registration_toast_updated_singular: "Registrierung aktualisiert.",
    registration_toast_updated_plural: "Registrierungen aktualisiert.",
    registration_toast_cancelled_singular: "Registrierung storniert.",
    registration_toast_cancelled_plural: "Registrierungen storniert.",
    clear: "Leeren",
    hello_user: "Hallo {{name}}!",
    email_sign_off: "Freundliche Grüße",
    event_registration_confirmation_subject: "Bestätigung deiner Anmeldung für {{title}}",
    event_registration_confirmation_lead: "Deine Anmeldung ist bestätigt.",
    event_registration_received_lead: "Deine Anmeldung ist eingegangen.",
    event_registration_waitlist_lead: "Du stehst auf der Warteliste.",
    event_registration_waitlist_detail: "Wird ein Platz frei, rückst du automatisch nach und bekommst eine E-Mail.",
    event_registration_update_subject: "Änderung deiner Anmeldung für {{title}}",
    event_registration_update_lead: "Deine Anmeldung wurde geändert.",
    event_registration_cancellation_subject: "Stornierung deiner Anmeldung für {{title}}",
    event_registration_cancellation_lead: "Deine Anmeldung wurde storniert.",
    event_registration_promotion_subject: "Dein Platz für {{title}} ist bestätigt",
    event_registration_promotion_lead: "Du hast einen Platz bekommen.",
    event_registration_promotion_detail: "Es ist ein Platz frei geworden und du bist von der Warteliste nachgerückt.",
    view_registration: "Anmeldung ansehen",
    guests: "Gäste",
    go_to_event: "Zur Veranstaltung",
    price: "Preis",
    event_price_currency: "Währung",
    stripe_not_configured_warning: "Stripe ist für diese Website nicht eingerichtet (STRIPE_SECRET_KEY fehlt). Mitglieder können sich nicht registrieren, solange die Zahlung nicht eingerichtet ist.",
    price_below_minimum: "Mindestbetrag ist {{min}}. Ein niedrigerer Preis kann nicht abgebucht werden.",
    currency_code_invalid: "Bitte einen dreistelligen Währungscode angeben (z. B. EUR).",
    amount_invalid: "Bitte einen gültigen Betrag eingeben.",
    complete_payment: "Zahlung jetzt abschließen",
    cancel_payment: "Zahlung abbrechen",
    event_payment_success_notice: "Vielen Dank! Deine Zahlung ist eingegangen und deine Anmeldung ist bestätigt. Du erhältst eine E‑Mail-Bestätigung.",
    event_payment_processing_notice: "Danke! Deine Zahlung wird verarbeitet. Deine Plätze bleiben reserviert, bis sie bestätigt ist – du erhältst dann eine E‑Mail.",
    event_payment_pending_notice: "Danke! Deine Zahlung wird noch bestätigt. Sobald sie eingegangen ist, erhältst du eine E‑Mail-Bestätigung.",
    event_payment_cancelled_notice: "Die Zahlung wurde abgebrochen. Deine Plätze bleiben ca. 30 Minuten reserviert – du kannst die Zahlung über deine Registrierung abschließen.",
    event_payment_not_configured: "Zahlungen sind für diese Veranstaltung noch nicht eingerichtet. Bitte kontaktiere die Veranstalter.",
    event_payment_session_error: "Die Zahlung konnte nicht gestartet werden. Bitte versuche es später erneut.",
    event_registration_paid_cancel_locked: "Bezahlte Plätze können nicht selbst storniert werden. Bitte kontaktiere die Veranstalter für eine Erstattung.",
    payment_processing_note: "Deine Zahlung wird verarbeitet – dein Platz ist reserviert.",
    event_registration_payment_processing: "Die Zahlung für diese Anmeldung wird gerade verarbeitet. Bitte warte, bis sie abgeschlossen ist.",
    event_registration_payment_processing_admin: "Die Zahlung ist bei Stripe noch offen (z. B. eine Lastschrift, die noch eingezogen wird). Stornieren lässt sie sich weder hier noch bei Stripe, bis Stripe das Ergebnis meldet – meist innerhalb weniger Werktage. Schlägt die Zahlung fehl, werden die Plätze automatisch freigegeben.",
    event_payment_refunded_notice: "Diese Zahlung wurde erstattet. Die Plätze sind nicht reserviert.",
    notes_too_long: "Die Notiz ist zu lang.",
    paid_registration_cancel_note: "Für die Stornierung eines bezahlten Platzes kontaktiere bitte die Veranstalter.",
    // Event ticket (inline-editable header card)
    price_empty_hint: "kostenlos",
    free_of_charge: "Kostenlos",
    price_per_person: "{{price}} pro Person",
    seats: "Plätze",
    unlimited: "unbegrenzt",
    seats_remaining_of: "{{remaining}} von {{total}} Plätzen frei",
    people: "Personen",
    people_count: "{{count}} Personen",
    person_count_singular: "1 Person",
    you: "Du",
    amount_paid_inline: "{{amount}} bezahlt",
    sold_out: "Ausgebucht",
    all_seats_taken: "Alle {{total}} Plätze sind vergeben.",
    waitlist_full: "Warteliste voll.",
    change_guests: "Gäste ändern",
    cancel_short: "Stornieren",
    registration_cancel_until_start: "Du kannst bis zum Beginn stornieren.",
    leave_waitlist: "Von der Warteliste streichen",
    registration_link_placeholder: "https://… oder E‑Mail-Adresse",
    // Member sign-up form and status card
    email_optional: "E‑Mail-Adresse (optional)",
    email_short: "E‑Mail",
    name_required: "Bitte einen Namen eingeben.",
    name_too_long: "Bitte einen kürzeren Namen eingeben (max. 255 Zeichen).",
    email_invalid: "Bitte eine gültige E‑Mail-Adresse eingeben.",
    email_too_long: "Bitte eine kürzere E‑Mail-Adresse eingeben (max. 255 Zeichen).",
    submit_registration: "Anmelden",
    submit_registration_paid: "Kostenpflichtig anmelden",
    payment_hold_note: "Deine Plätze bleiben {{minutes}} Minuten reserviert – so lange hast du Zeit zum Bezahlen.",
    complete_registration_title: "Anmeldung abschließen",
    complete_registration_note: "Du bist eingeloggt als {{name}} – prüfe deine Angaben und bestätige die Anmeldung.",
    registered_title: "Angemeldet",
    registered_guests_count: "{{count}} Personen angemeldet",
    registered_guests_count_singular: "1 Person angemeldet",
    payment_open_title: "Zahlung offen",
    payment_open_until: "Deine Plätze sind bis {{time}} reserviert.",
    payment_confirming_title: "Zahlung wird bestätigt …",
    payment_confirming_note: "Das dauert nur einen Moment – deine Plätze sind reserviert.",
    waitlisted_title: "Auf der Warteliste",
    waitlist_position_note: "Du rückst automatisch nach, sobald ein Platz frei wird.",
    refunded_note: "Deine Zahlung wurde erstattet. Die Anmeldung ist damit aufgehoben.",
    cancel_my_registration: "Anmeldung stornieren",
    confirm_cancel_my_registration: "Wirklich stornieren?",
    add_guests: "Gäste hinzufügen",
    // Admin guest list
    guest_list: "Gästeliste",
    guest_list_summary_seats: "{{taken}} von {{total}} Plätzen",
    guest_list_summary_paid: "{{count}} bezahlt",
    guest_list_summary_unpaid: "{{count}} offen",
    guest_list_summary_pending: "{{count}} in Zahlung",
    guest_list_summary_waitlist: "{{count}} auf der Warteliste",
    guest_list_empty: "Noch keine Anmeldungen.",
    show: "Anzeigen",
    hide: "Ausblenden",
    email_all: "E‑Mail an alle",
    csv: "CSV",
    payment: "Zahlung",
    payment_method: "Zahlungsart",
    amount: "Betrag",
    paid_at: "Eingegangen am",
    notes: "Notiz",
    payment_state_paid: "Bezahlt",
    payment_state_unpaid: "Offen",
    payment_state_comp: "Frei",
    payment_state_refunded: "Erstattet",
    payment_state_pending: "In Zahlung",
    payment_state_processing: "In Bearbeitung",
    payment_state_free: "—",
    payment_method_stripe: "Stripe",
    payment_method_bank_transfer: "Überweisung",
    payment_method_cash: "Bar",
    payment_method_invoice: "Rechnung",
    payment_method_comp: "Frei",
    send_receipt: "E‑Mail senden",
    mark_as_paid: "Als bezahlt markieren",
    mark_as_comp: "Als frei markieren",
    mark_as_unpaid: "Zahlung zurücksetzen",
    payment_recorded: "Zahlung erfasst.",
    payment_cleared: "Zahlung zurückgesetzt.",
    event_registration_payment_stripe_locked: "Stripe-Zahlungen können nur über Stripe erstattet werden.",
    confirm_remove_guest: "{{name}} von der Gästeliste entfernen?",
    saved: "Gespeichert",
    event_registration_email_recipients_unpaid: "Unbezahlt",
    event_registration_payment_failed_subject: "Zahlung fehlgeschlagen: {{title}}",
    event_registration_payment_failed_lead: "Deine Zahlung ist fehlgeschlagen.",
    event_registration_payment_failed_detail: "Die Zahlung konnte nicht eingezogen werden, deshalb wurde deine Anmeldung storniert. Solange noch Plätze frei sind, kannst du dich neu anmelden.",
    event_registration_payment_received_subject: "Zahlung erhalten: {{title}}",
    event_registration_payment_received_lead: "Danke für deine Zahlung, dein Platz ist bestätigt.",
    series_cancellation_subject: "{{count}} Veranstaltungen abgesagt",
    series_cancellation_message: "Die folgenden {{count}} Veranstaltungen, für die du registriert warst, wurden abgesagt:",
    event_registration_admin_notification_subject: "[{{type}}] {{title}}",
    event_registration_admin_notification_greeting: "Hallo,",
    event_registration_admin_notification_message: "Es gab eine {{type}} für «{{title}}».",
    event_registration_admin_notification_type_new: "Neue Anmeldung",
    event_registration_admin_notification_type_update: "Aktualisierung",
    event_registration_admin_notification_type_cancel: "Stornierung",
    event_registration_admin_notification_type_promotion: "Nachrückung von der Warteliste",
    event_registration_admin_notification_footer: "Diese E-Mail wurde automatisch von {{site_name}} gesendet.",
    registration_details: "Registrierungsdetails",
    registered_by: "Registriert von",
    on_behalf_of: "Im Namen von",
    event_body_notice: "Füge Text, Bilder, Videos und andere Inhalte zu deiner Veranstaltungsseite hinzu.",
    registration_settings: "Registrierungs-Einstellungen",
    event_tab_schedule: "Termin",
    event_tab_registration: "Anmeldung",
    event_status_question: "Findet die Veranstaltung statt?",
    event_status_option_scheduled: "Ja, wie geplant",
    registration_mode_question: "Wie melden sich Gäste an?",
    registration_mode_option_here: "Über diese Seite",
    registration_mode_option_link: "Externer Link",
    registration_mode_option_none: "Keine",
    price_per_person_label: "Preis pro Person",
    seat_count_label: "Anzahl Plätze",
    show_remaining_seats_public: "Freie Plätze öffentlich anzeigen",
    max_guests_per_registration_label: "Max. Personen pro Anmeldung",
    waitlist_seats_label: "Plätze auf der Warteliste",
    registration_link_label: "Link zur Anmeldung",
    registration_button_text_label: "Text auf dem Anmelde-Button",
    registration_notification_label: "Neue Anmeldungen per E-Mail an",
    confirm_changes: "Änderungen bestätigen",
    cancel_all_registrations: "Alle stornieren",
    cancel_registration: "Registrierung stornieren",
    count_of_registrations_marked_for_deletion: "{{count}}× Registrierungen sind zur Stornierung markiert",
    one_registration_marked_for_deletion: "1× Registrierung ist zur Stornierung markiert",
    open_tasks: "Offene Aufgaben",
    what_do_you_want_to_share: "Was möchtest du teilen?",
    set_heading_size: "Überschrift",
    no_heading: "Keine Überschrift",
    heading_level: "Überschrift Ebene {{level}}",
    heading_paragraph_style: "Titel im Absatzstil",
    terms_and_conditions: "Nutzungsbedingungen",
    privacy_policy: "Datenschutzerklärung",
    data_processing: "Datenverarbeitung",
    email_signature: "E‑Mail Signatur",
    my_email_signature: "Meine E-Mail-Signatur",
    signature_template: "Vorlage",
    signature_template_title: "Signatur-Vorlage",
    signature_preview_phone: "Smartphone",
    signature_preview_dark: "Dark Mode",
    signature_preview_brand_font: "Webfont",
    signature_field_name: "Name",
    signature_field_role: "Funktion",
    signature_field_email: "E-Mail",
    signature_field_phone: "Telefon",
    signature_field_mobile: "Mobil",
    signature_field_address: "Anschrift",
    signature_field_website: "Website",
    signature_field_links: "Links",
    signature_field_footnote: "Fußnote",
    signature_placeholder_name: "Vor- und Nachname",
    signature_placeholder_role: "Funktion",
    signature_placeholder_email: "name@firma.de",
    signature_placeholder_phone: "Telefon",
    signature_placeholder_mobile: "Mobil",
    signature_placeholder_address: "Straße und Hausnummer, PLZ Ort",
    signature_placeholder_footnote: "Rechtliche Angaben",
    signature_buttons: "Buttons",
    signature_add_link: "Link hinzufügen",
    signature_add_button: "Button hinzufügen",
    signature_link_label: "Text",
    signature_copy_description_outlook: "Kopiert die Signatur als formatierten Text für den Signatur-Editor von Outlook.",
    signature_copy_description_ios: "Kopiert die Signatur als formatierten Text zum Einfügen in die Einstellungen von iOS Mail.",
    signature_copy_description_apple_mail: "Kopiert die Signatur als vollständiges HTML-Dokument.",
    signature_copy_description_gmail: "Kopiert die Signatur als formatierten Text zum direkten Einfügen in Gmail.",
    signature_sample_phone: "+49 000 000 00 00",
    signature_sample_role: "Funktion",
    signature_install_intro: "Wähle dein E-Mail-Programm",
    signature_site_font: "Website",
    signature_details_font: "Text",
    signature_fonts: "Schrift",
    signature_color: "Farbe",
    signature_fields_hint: "Anschrift und Fußnote trägst du direkt in die Signatur ein. Sie gelten für alle.",
    signature_lines_hint: "Eine Zeile pro Titel, Funktion oder Zugehörigkeit.",
    signature_links_hint: "Profile oder Websites.",
    signature_buttons_hint: "Zum Beispiel deine Seite für Terminbuchungen.",
    signature_hint: "Leere Felder erscheinen nicht in der Signatur.",
    signature_redo: "Wiederholen",
    signature_edit_template: "Vorlage bearbeiten",
    signature_button_example: "Termin buchen",
    signature_layout_logo_top: "Logo oben",
    signature_layout_logo_top_description: "Logo oben, der Text darunter eingerückt",
    signature_layout_logo_top_flush: "Logo oben, bündig",
    signature_layout_logo_top_flush_description: "Logo oben, der Text darunter in einer Spalte",
    signature_layout_logo_left: "Logo links",
    signature_layout_logo_left_description: "Logo in eigener Spalte, auf Telefonen darüber",
    signature_layout_logo_middle: "Logo mittig",
    signature_layout_logo_middle_description: "Logo zwischen Name und Kontaktdaten",
    signature_layout_logo_below_labels: "Logo unten, beschriftet",
    signature_layout_logo_below_labels_description: "Beschriftete Zeilen, Logo, Linie und Fußnote",
    signature_layout_logo_below: "Logo unten",
    signature_layout_logo_below_description: "Schlichte Zeilen, das Logo am Ende",
    signature_layout_compact: "Kompakt",
    signature_layout_compact_description: "Zwei Zeilen und ein kleines Logo, ohne Buttons",
    signature_logo_site: "Website-Logo",
    signature_logo_image: "Anderes Bild",
    signature_logo_width: "Breite in px",
    signature_no_logo: "Kein Logo",
    signature_undo: "Rückgängig",
    signature_install: "Installieren",
    signature_template_saved: "Vorlage gespeichert",
    signature_save_failed: "Speichern hat nicht geklappt. Bitte versuche es noch einmal.",
    signature_install_title: "Meine E-Mail-Signatur installieren",
    signature_client_gmail: "Gmail",
    signature_client_apple_mail: "macOS Mail",
    signature_client_ios: "iOS Mail",
    signature_client_outlook_web: "Outlook Web",
    signature_client_outlook_windows: "Outlook Windows",
    signature_client_outlook_mac: "Outlook Mac",
    signature_install_copy_title: "Signatur kopieren",
    signature_copy: "Signatur kopieren",
    signature_copied: "Signatur kopiert",
    signature_copy_failed: "Kopieren hat nicht geklappt. Erlaube dem Browser den Zugriff auf die Zwischenablage und versuche es noch einmal.",
    signature_install_add_gmail: "Zu Gmail hinzufügen",
    signature_install_add_apple_mail: "Zu Apple Mail hinzufügen",
    signature_install_add_ios: "Zu iOS Mail hinzufügen",
    signature_install_add_outlook_web: "Zu Outlook Web hinzufügen",
    signature_install_add_outlook_windows: "Zu Outlook Windows hinzufügen",
    signature_install_add_outlook_mac: "Zu Outlook Mac hinzufügen",
    signature_steps_gmail: "Öffne [mail.google.com](https://mail.google.com) und melde dich an.\nKlicke auf das Zahnrad → „Alle Einstellungen aufrufen“.\nScrolle zum Abschnitt „Signatur“.\nKlicke auf „Neu erstellen“, gib einen Namen ein und klicke auf „Erstellen“.\nFüge die kopierte Signatur in den Texteditor ein.\nLass das Logo in der eingefügten Größe ({{width}} px breit).\nLege die Signatur für neue E-Mails und Antworten als Standard fest (optional).\nKlicke unten auf „Änderungen speichern“.",
    signature_note_gmail: "Hinweis: Gmail unterstützt keine eigenen Webfonts, die Schrift kann daher anders aussehen.\nDark Mode: Aus Gmail gesendete E-Mails behalten in Apple Mail eventuell auch im Dark Mode einen weißen Hintergrund, weil Gmail die Dark-Mode-Angaben der Signatur entfernen kann.",
    signature_steps_apple_mail: "Öffne Apple Mail → Menü „Mail“ → „Einstellungen“.\nKlicke auf den Tab „Signaturen“ → wähle „Alle Signaturen“.\nKlicke auf „+“, um eine neue Signatur hinzuzufügen.\nSchreib den Platzhalter `XXXXXXX` in das Signaturfeld.\nZiehe die Signatur auf dein E-Mail-Konto und lege sie unter „Signatur auswählen“ als Standard fest.\nSchließe die Einstellungen und beende Apple Mail vollständig (⌘Q).\nÖffne den Finder, drücke ⇧⌘G und gib `~/Library/Mail` ein.\nÖffne den Ordner mit der höchsten „V“-Nummer → „MailData“ → „Signatures“.\nSuche die neueste Datei mit der Endung `.mailsignature` (nach „Änderungsdatum“ sortieren).\nRechtsklick → „Öffnen mit > TextEdit“.\nNutze in TextEdit den reinen Textmodus. Lass die Kopfzeilen über der ersten Leerzeile stehen und ersetze das gesamte HTML darunter durch deine kopierte Signatur.\nSichere und schließe TextEdit.\nRechtsklick auf die Datei → „Informationen“ → „Geschützt“ aktivieren.\nÖffne Apple Mail und prüfe, ob deine Signatur richtig aussieht.",
    signature_note_apple_mail: "Wichtig: Durch das Schützen der Datei überschreibt Apple Mail deine Signatur nicht.",
    signature_steps_ios: "Öffne „Einstellungen“ → „Apps“ → „Mail“ → „Signatur“.\nWähle „Alle Accounts“ oder ein bestimmtes Konto.\nFüge die kopierte Signatur in das Textfeld ein.",
    signature_note_ios: "Hinweis: iOS unterstützt keine Webfonts, die Schrift kann daher anders aussehen.",
    signature_steps_outlook_web: "Öffne [outlook.office.com](https://outlook.office.com) (Firmenkonto) oder [outlook.live.com](https://outlook.live.com) (privates Konto) und melde dich an.\nKlicke auf das Zahnrad → „Alle Outlook-Einstellungen anzeigen“.\nWähle „E-Mail“ → „Verfassen und beantworten“.\nKlicke unter „E-Mail-Signatur“ auf „Neue Signatur“.\nFüge deine Signatur in das Textfeld ein.",
    signature_steps_outlook_windows: "Öffne Outlook und klicke in der Menüleiste auf „Datei“.\nWähle „Optionen“ → Tab „E-Mail“.\nKlicke auf „Signaturen“ → „Neu“.\nGib deiner Signatur einen Namen und füge sie in das Textfeld ein.\nKlicke zum Speichern auf „OK“.",
    signature_steps_outlook_mac: "Wähle in der Menüleiste „Outlook“ → „Einstellungen“ → „Signaturen“.\nKlicke auf das Symbol „+“.\nBenenne deine Signatur (Stift anklicken oder Namen doppelklicken).\nLeere das Textfeld: ⌘A, dann Entf.\nFüge die Signatur in das Textfeld ein (⌘V).\nSieht sie anders aus und fragt Outlook nach der Formatierung, wähle „Ursprüngliche Formatierung beibehalten“.\nWähle sie optional unten unter „Standardsignaturen festlegen“.",
    signature_install_test_note: "Schick dir danach eine Test-E-Mail und prüfe die empfangene Signatur. Die Vorschau bildet nicht jedes E-Mail-Programm nach.",
    signature_text: "Signatur Text",
    enter_signature_text: "Signatur Text einfügen",
    signature_image: "Signatur Bild",
    event_status: "Veranstaltungsstatus",
    event_status_scheduled: "Geplant",
    event_status_cancelled: "Abgesagt",
    event_status_postponed: "Verschoben",
    event_status_tooltip: "Abgesagt: Neue Anmeldungen sind geschlossen und Erinnerungs-E-Mails werden nicht mehr versendet. Bestehende Anmeldungen können weiterhin storniert werden. Verschoben: Gleiches Verhalten wie abgesagt, aber mit dem Hinweis „bis auf Weiteres verschoben“.",
    registration_mode_internal: "Aktiv",
    registration_mode_external: "individuell",
    registration_mode_disabled: "Inaktiv",
    registration: "Registrierung",
    remaining_spots: "Nur noch {{count}} Plätze verfügbar!",
    remaining_spot_singular: "Nur noch 1 Platz verfügbar!",
    email_signature_image_requirements: "Das Signaturbild sollte ein optimiertes Bild mit einer Breite von weniger als 600px sein. Dateiformate wie SVG, WebP, AVIF werden in E-Mail-Anwendungen nur teilweise unterstützt.",
    download_registrations: "Registrierungen herunterladen ({{count}}×)",
    export_csv: "Exportieren",
    event_date: "Veranstaltungsdatum",
    registrations_exceed_max_attendees: "Entschuldigung. Die maximale Teilnehmerzahl ist schon erreicht",
    registrations_exceed_max_guests: "Du kannst nicht mehr Gäste anmelden, als pro Anmeldung erlaubt sind.",
    waitlist: "Warteliste",
    get_off_the_waitlist: "Die Veranstaltung ist bereits ausgebucht. Diese Registrierungen rücken automatisch nach, sobald Plätze frei werden",
    waitlist_spots: "{{count}} Plätze verfügbar auf der Warteliste",
    waitlist_spot_singular: "1 Platz verfügbar auf der Warteliste",
    waitlist_capacity: "Warteliste Kapazität",
    event_is_fully_booked: "Vollständig ausgebucht",
    event_is_cancelled: "Veranstaltung abgesagt",
    event_is_postponed: "Veranstaltung verschoben",
    event_cancelled_notice: "Diese Veranstaltung ist derzeit abgesagt. Neue Anmeldungen sind geschlossen. Bestehende Anmeldungen können storniert werden.",
    event_postponed_notice: "Diese Veranstaltung ist bis auf Weiteres verschoben. Neue Anmeldungen sind geschlossen. Bestehende Anmeldungen können storniert werden.",
    event_inactive_registration_changes_restricted: "Diese Veranstaltung ist abgesagt oder verschoben. Du kannst nur bestehende Anmeldungen stornieren.",
    // Series/recurring events
    series_event: "Serientermin",
    series_base_event: "Basis-Event",
    go_to_base_event: "Zum Basis-Event",
    recurrence: "Wiederholung",
    does_not_repeat: "Einmalig",
    repeats_daily: "Täglich",
    repeats_weekly: "Wöchentlich",
    repeats_monthly: "Monatlich",
    series_end_date: "Serienende",
    series_will_create_n_events: "Es werden {{count}} Termine erstellt",
    series_creating_events: "{{count}} Termine werden erstellt…",
    series_created: "Serie erstellt: {{count}} Termine",
    edit_this_event_only: "Du bearbeitest nur diesen Termin. Änderungen betreffen keine anderen Termine dieser Serie.",
    edit_all_future_events: "Alle zukünftigen Termine bearbeiten",
    edit_all_future_events_confirm: "Diese Änderungen werden auf alle zukünftigen Termine dieser Serie angewendet.",
    delete_future_events: "Zukünftige Termine löschen",
    delete_entire_series: "Gesamte Serie löschen",
    delete_this_and_future_events: "Diesen und folgende Termine löschen",
    delete_all_events: "Alle Termine löschen",
    notify_registrants_of_cancellation: "Angemeldete Teilnehmer per E-Mail benachrichtigen",
    delete_empty_only: "Nur Termine ohne Anmeldungen löschen",
    series_impact_summary: "{{total}} zukünftige Termine, {{with_reg}} haben Anmeldungen ({{reg_count}} Teilnehmer insgesamt)",
    series_impact_no_registrations: "{{total}} zukünftige Termine, keine Anmeldungen",
    part_of_series: "Teil einer Serie ({{frequency}})",
    series_delete_confirm_title: "Serientermine löschen",
    series_dates_preview_title: "Terminübersicht",
    base_event: "Basistermin",
    series_bulk_select_hint: "Wähle die Felder aus, deren aktuellen Wert du auf alle zukünftigen Termine übertragen möchtest.",
    apply_to_all_future: "Auf alle zukünftigen Termine anwenden",
    save_this_event_only: "Nur diesen Termin speichern",
    series_save_scope_title: "Änderungen auf Serie anwenden?",
    series_save_scope_description: "Dieser Termin wurde gespeichert. Wähle aus, welche Felder auf alle zukünftigen Termine übertragen werden sollen.",
    series_confirm_override_title: "Änderungen bestätigen",
    series_confirm_override_description: "{{fields}} Felder werden bei {{count}} zukünftigen Terminen überschrieben.",
    confirm_override: "{{count}} Termine aktualisieren",
    series_field_content: "Inhalt",
    series_field_subtitle: "Untertitel",
    series_field_link: "Link",
    series_field_time: "Uhrzeit",
    series_field_pricing: "Preis",
    series_too_many_occurrences: "Zu viele Termine ({{count}}). Maximal {{max}} möglich.",
    series_correct_end_date: "Enddatum anpassen",
    series_promote_notice: "Beim Speichern wird dieser Termin in eine Serie umgewandelt und {{count}} weitere Termine erstellt. Die Wiederholung kann danach nicht mehr geändert werden.",
    series_ends: "Serienende",
    series_end_by_date: "Am Datum",
    series_end_after_count: "Nach Anzahl",
    series_repeat_count: "Anzahl Termine",
    series_occurrences_unit: "Termine",
    series_interval: "Intervall",
    series_interval_every: "Alle",
    series_interval_unit_daily_singular: "Tag",
    series_interval_unit_daily_plural: "Tage",
    series_interval_unit_weekly_singular: "Woche",
    series_interval_unit_weekly_plural: "Wochen",
    series_interval_unit_monthly_singular: "Monat",
    series_interval_unit_monthly_plural: "Monate",
    detach_from_series: "Von Serie lösen",
    detach_from_series_title: "Von Serie lösen?",
    detach_from_series_description: "Dieser Termin wird von der Serie gelöst und zu einem eigenständigen Einzeltermin. Zukünftige Änderungen an der Serie betreffen diesen Termin dann nicht mehr.",
    detach_from_series_confirm: "Lösen",
    detach_from_series_success: "Termin von Serie gelöst",
    select_all: "Alle auswählen",
    deselect_all: "Alle abwählen",
    confirm_cancel_registrations: "Bist du sicher, dass du diese Registrierungen stornieren möchtest?",
    waitlist_capacity_warning: "Achtung: {{current}} Personen sind derzeit auf der Warteliste. Eine Reduzierung der Kapazität auf {{new}} entfernt keine bestehenden Wartelistenregistrierungen, verhindert aber neue.",
    add_to_waitlist: "Auf Warteliste eintragen",
    greeting_user: "Hallo {{name}}!",
    registration_email_sent: "Wir haben dir eine E‑Mail an {{email}} für deine Registrierungen gesendet.",
    registration_email_notice: "E‑Mail an {{email}} gesendet.",
    max_attendees_tooltip: "Legt die maximale Teilnehmerzahl fest. Nur bis zu dieser Zahl können an der Veranstaltung teilnehmen (ohne Warteliste).",
    max_guests_per_registration_tooltip: "Bestimmt die maximale Anzahl an Personen, die mit einer Registrierung angemeldet werden können. Dies ermöglicht z.B. Gruppenanmeldungen oder die Anmeldung mit Begleitperson. Beispiel: Bei einem Wert von 2 kann jede Person sich selbst und eine Begleitperson anmelden.",
    waitlist_capacity_tooltip: "Definiert die Anzahl zusätzlicher Plätze auf der Warteliste. Dieser Wert deckt potenzielle Stornierungen ab. Er sollte so gewählt werden, dass die Warteliste nicht zu groß wird und keine falschen Hoffnungen geweckt werden. Beispiel: Bei 30 max. Teilnehmern und 10 Wartelistenplätzen sind insgesamt 40 Anmeldungen möglich.",
    signup_data_processing_consent_required_description: "Aktivieren diese Option, wenn deine Besucher aktiv zur Datenverarbeitung zustimmen müssen.",
    consent_required: "Zustimmung erforderlich",
    registered: "Registriert",
    copied_to_clipboard: "{{value}} kopiert",
    display_capacity: "Anzeige der Kapazität",
    display_capacity_tooltip: "Zeige die Kapazität der Veranstaltung auf der Veranstaltungsseite für Nicht-Admins an.",
    registration_notification_email: "Benachrichtigungs-E-Mail",
    registration_notification_email_tooltip: "E-Mail-Adresse, die bei neuen Registrierungen, Änderungen oder Stornierungen benachrichtigt wird.",
    email_registrants: "Neue E-Mail an registrierte Benutzer",
    event_registration_email_popover_title: "E‑Mail an registrierte Benutzer",
    event_registration_email_recipients_group: "Empfängergruppe",
    event_registration_email_recipients_all: "Alle",
    event_registration_email_recipients_registered: "Nur registriert",
    event_registration_email_recipients_waitlist: "Nur Warteliste",
    event_registration_email_recipients: "Empfänger-E-Mails",
    event_registration_email_recipients_hint: "Empfänger mit E-Mail-Adresse: {{count}}. Die Liste lässt sich bearbeiten.",
    event_registration_email_recipients_placeholder: "name@example.com",
    event_registration_email_subject: "Betreff",
    event_registration_email_subject_placeholder: "Betreff eingeben",
    event_registration_email_body: "Nachricht",
    event_registration_email_body_placeholder: "Nachricht (nur Text, mehrere Zeilen möglich)",
    event_registration_email_preview_message: "Nachricht (wie versendet)",
    event_registration_email_preview_notice: "Hinweis: Das E-Mail-Template und die konfigurierte Signatur werden automatisch hinzugefügt.",
    event_registration_email_send: "E-Mail senden",
    event_registration_email_sending: "E-Mail wird gesendet...",
    event_registration_email_sent_success: "{{count}} E-Mails gesendet.",
    event_registration_email_sent_success_singular: "1 E-Mail gesendet.",
    event_registration_email_sent_partial: "{{sent}} gesendet, {{failed}} fehlgeschlagen.",
    event_registration_email_dialog_title: "E-Mail an Registrierte",
    event_registration_email_review: "Vorschau prüfen",
    event_registration_email_back_to_edit: "Zurück zur Bearbeitung",
    event_registration_email_send_now: "Jetzt E-Mails senden",
    event_registration_email_progress: "Versendet: {{processed}} von {{total}}",
    event_registration_email_status_pending: "Wartet auf Versandstart...",
    event_registration_email_status_running: "E-Mails werden versendet...",
    event_registration_email_status_sent: "Alle E-Mails wurden gesendet.",
    event_registration_email_status_partial: "Ein Teil der E-Mails konnte nicht gesendet werden.",
    event_registration_email_status_failed: "E-Mail-Versand fehlgeschlagen.",
    event_registration_email_progress_details: "Gesendet: {{sent}} · Fehlgeschlagen: {{failed}}",
    event_registration_email_failed_recipients: "Fehlgeschlagene Empfänger",
    event_registration_email_compose_another: "Weitere E-Mail verfassen",
    event_registration_email_done: "Fertig",
    event_registration_email_send_failed: "E-Mails konnten nicht gesendet werden.",
    event_registration_message_subject_required: "Bitte einen Betreff eingeben.",
    event_registration_message_subject_too_long: "Der Betreff ist zu lang (max. {{limit}} Zeichen).",
    event_registration_message_body_required: "Bitte eine Nachricht eingeben.",
    event_registration_message_body_too_long: "Die Nachricht ist zu lang (max. {{limit}} Zeichen).",
    event_registration_message_no_recipients: "Bitte mindestens eine gültige Empfänger-E-Mail eingeben.",
    event_registration_message_too_many_recipients: "Zu viele Empfänger (max. {{limit}}).",
    event_registration_message_invalid_recipients: "Ungültige E-Mail-Adressen: {{emails}}",
    event_registration_message_job_already_running: "Es läuft bereits ein E-Mail-Versand. Bitte warte, bis er abgeschlossen ist.",
    event_registration_message_job_not_found: "Der E-Mail-Versand konnte nicht gefunden werden.",
    event_registration_message_job_timed_out: "Der E-Mail-Versand hat zu lange gedauert und wurde beendet.",
    event_registration_email_send_error: "Beim E-Mail-Versand ist ein Fehler aufgetreten.",
    max_guests_limit_reached: "Du bist registriert - keine weiteren Gäste können hinzugefügt werden.",
    messenger_link_prefill_title: "Vorausgefüllte Nachricht (optional)",
    messenger_link_prefill_subtitle: "Der Benutzer bekommt diesen Text im Chat vorgeschlagen, kann ihn aber beliebig anpassen.",
    messenger_link_description: "Optional vorausgefüllt",
    messenger: "Messenger",
    insert_link: "Link einfügen",
    insert_email: "E‑Mail einfügen",
    insert_phone: "Telefon einfügen",
    internal_notes: "Notizen",
    report_poster_details: 'Poster melden:\nTitel: {{title}}\nAutor: {{author}}\nDatum: {{date}}\n\nGrund der Meldung: [Bitte füge hier deinen Grund ein]',
    searching: "Suche...",
    no_results_found: "Keine Ergebnisse gefunden",
    start_typing_to_search: "Starte mit der Eingabe um zu suchen...",
    select_logo_size: "Logo Größe auswählen",
    tall: "Hoch",
    short: "Kurz",
    show_label_with_image: "Beschriftung mit Bild anzeigen",
    change_nav_item: "Eintrag ändern",
    button_design: "Button Design",
    change_image_size: "Bildgröße ändern",
    represented_by: "Repräsentiert durch",
    delegatory: "Bevollmächtigt von",
    tomorrow: "Morgen",
    this_week: "Diese Woche",
    events_this_month: "Diesen Monat",
    archive: "Archiv",
    upcoming_events: "Anstehend",
    past_events: "Vergangene Veranstaltungen",
    past: "Vergangen",
    my_event_registrations: "Meine Registrierungen",
    invoices: "Rechnungen",
    need_invoice: "Ich brauche eine Rechnung",
    customer_portal_headline: "Rechnungen, Rechnungsadresse und USt-IdNr. verwalten",
    no_event_registrations: "Du hast dich noch für keine Veranstaltung angemeldet.",
    view_event: "Zur Veranstaltung",
    manage_my_registration: "Anmeldung verwalten",
    registered_on: "Angemeldet am",
    user_profile_description: "Login für nicht angemeldete Benutzer",
    confirm_delete_color_set: "Bist du sicher, dass du diese Farbpalette löschen möchtest? Alle Elemente, die diese Farbpalette verwenden, werden auf die Standardfarbpalette zurückgesetzt.",
    select_a_color_set: "Wähle eine Farbpalette",
    color_name: "Farbname",
    cannot_delete_default: "Standardfarbpalette kann nicht gelöscht werden",
    cannot_delete_last_color: "Die letzte Farbpalette kann nicht gelöscht werden",
    drag_to_reorder_default: "Ziehe eine andere Farbe nach oben, um sie als Standard festzulegen",
    add_color_set: "Farbpalette hinzufügen",
    emphasis: "Akzent",
    color_input_hint: "Füge HEX oder RGB ein, um zu OKLCH zu konvertieren",
    default: "Standard",
    variable_font: "Variable Schrift",
    static_font: "Statische Schrift",
    italic: "Kursiv",
    normal: "Normal",
    minor_second: "Kleine Sekunde",
    major_second: "Große Sekunde",
    minor_third: "Kleine Terz",
    major_third: "Große Terz",
    perfect_fourth: "Reine Quarte",
    augmented_fourth: "Übermäßige Quarte",
    perfect_fifth: "Reine Quinte",
    golden_ratio: "Goldener Schnitt",
    font_sizes: "Schriftgrößen",
    font_sizes_help: "Jeder Stil liegt auf einer Stufe der Skala. Die Größen werden für Telefon und Desktop getrennt berechnet; dazwischen gilt der Mittelwert.",
    scale_phone: "Telefon · bis 768 px",
    scale_desktop: "Desktop · ab 1281 px",
    scale_phone_short: "Telefon",
    scale_desktop_short: "Desktop",
    base_size: "Grundgröße",
    scale_ratio: "Verhältnis",
    scale_step: "Stufe",
    sizes_follow_scale: "Alle Größen folgen der Skala.",
    sizes_differ_from_scale: "Einzelne Größen weichen von der Skala ab.",
    apply_scale: "Skala anwenden",
    style_heading1: "Überschrift 1",
    style_heading2: "Überschrift 2",
    style_heading3: "Überschrift 3",
    style_body: "Fließtext",
    style_control: "Bedienelemente",
    style_caption: "Bildunterschrift",
    style_preamble: "Vorspann",
    emphasis_background: "Akzent Hintergrund",
    emphasis_foreground: "Akzent Vordergrund",
    team: "Team",
    id: "ID",
    invalid_video_format: "Ungültiges Videoformat. Bitte verwende MP4 oder WebM.",
    video_resolution_too_high: "Die Videoauflösung ist zu hoch (max. {{dimension_limit}}px an der längsten Kante). Bitte kodieren das Video mit einem kostenlosen Tool wie Handbrake in eine niedrigere Auflösung um.",
    video_file_too_large: "Das Video ist zu groß (max. {{size_limit_mb}}MB). Bitte komprimiere dein Video mit einem kostenlosen Tool wie Handbrake.",
    image_file_too_large: "Das Bild ist zu groß. Bitte verwende kleinere, web-optimierte Bilder ({<{size_limit_kb}}kb).",
    unsupported_image_format_on_browser: "Die HEIC/HEIF-Verarbeitung wird nur von Safari unterstützt. Bitte konvertiere das Bild zuerst in JPEG oder PNG.",
    unsupported_file_type: "Nicht unterstützter Dateityp. Bitte lade eine unterstützte Bild- oder Videodatei hoch.",
    unknown_upload_error: "Beim Verarbeiten der Datei ist ein unbekannter Fehler aufgetreten. Bitte versuche es erneut.",
    upload_failed: "Upload fehlgeschlagen. Prüfe deine Verbindung und versuche es erneut.",
    image_upload_too_large: "Das Bild ist zu groß (max. {{size_limit_mb}} MB). Bitte wähle ein kleineres Bild.",
    image_upload_unsupported: "Dieses Bild kann nicht verwendet werden. Bitte wähle ein anderes Bild.",
    uploading: "Wird hochgeladen",
    optimizing: "Wird optimiert",
    optimizing_safe_to_leave: "Wird optimiert — Speichern und Verlassen jederzeit möglich",
    finishing_uploads: "{{count}} Upload(s) werden abgeschlossen …",
    upload_in_progress_warning: "Ein Upload läuft noch.",
    added_to_library: "Zur Bibliothek hinzugefügt",
    open_media_library: "Mediathek öffnen",
    upload_media: "Medien hochladen",
    drop_or_paste_files: "Dateien hierher ziehen oder einfügen (Cmd+V)",
    each_file_becomes_entry: "Jede Datei wird ein eigener Beitrag in der Mediathek.",
    image_credits: "Bildnachweis",
    save_failed: "Speichern fehlgeschlagen",
    already_in_library: "Bereits in der Bibliothek — vorhandener Eintrag wird verwendet",
    pasted_anchors_removed: "Sprungmarken entfernt — sie zeigten auf Abschnitte der ursprünglichen Seite",
    retry: "Erneut versuchen",
    add_media: "Medien hinzufügen",
    upload_images: "Bilder hochladen",
    crop_to_fill: "Füllend zuschneiden",
    show_whole_image: "Ganzes Bild zeigen",
    image_fit: "Bildanpassung",
    whole_image: "Ganzes Bild",
    video: "Video",
    preview_card: "Vorschaukarte",
    show_in_search: "In der Suche anzeigen",
    not_in_search: "Nicht in der Suche",
    all_formats: "Alle Seitenverhältnisse",
    asset_id: "Pfad",
    mime_type: "Dateityp",
    variants: "Varianten",
    variant_count: "Varianten",
    not_applicable: "–",
    pending: "Ausstehend",
    ready: "Fertig",
    errors: "Fehler",
    image_variant_coverage: "Bildvarianten-Abdeckung",
    images_with_variants: "Bilder mit Varianten",
    missing: "fehlend",
    pending_jobs: "ausstehende Jobs",
    errored_jobs: "fehlgeschlagene Jobs",
    select_files: "Dateien wählen",
    drop_or_select_files: "Dateien hierher ziehen oder klicken zum Auswählen",
    visible_in_all_formats: "In allen {{count}} Seitenverhältnissen sichtbar",
    cropped_by_some_formats: "Wird bei manchen Seitenverhältnissen beschnitten",
    never_cropped: "Ganzes Bild — wird nie beschnitten",
    crop: "Zuschneiden",
    crop_format: "Format",
    crop_free: "Frei",
    crop_original: "Original",
    crop_reset: "Zurücksetzen",
    cropping: "Wird zugeschnitten …",
    crop_failed: "Zuschneiden fehlgeschlagen",
    crop_area: "Bildausschnitt",
    entry_default: "Standard des Eintrags",
    alt_text_missing: "Alt-Text fehlt",
    aspect_ratio_label: "Seitenverhältnis",
    auto: "Automatisch",
    entry_changed_reload_confirm: "Diese Seite wurde inzwischen von jemand anderem geändert. OK: neu laden (deine Änderungen gehen verloren). Abbrechen: deine Version behalten und beim nächsten Speichern überschreiben.",
    draft_restore_confirm: "Es gibt einen nicht gespeicherten Entwurf dieser Seite. Entwurf wiederherstellen?",
    entry_save_not_allowed: "Mit diesem Konto kannst du hier nichts speichern. Melde dich mit einem Admin-Konto an.",
    uploaded_images_stay_in_library: "Bereits hochgeladene Bilder bleiben in der Bibliothek erhalten.",
    video_duration_too_long: "Das Video ist zu lang (max. {{duration_limit}} Sekunden). Bitte kürze das Video.",
    video_metadata_error: "Videometadaten konnten nicht gelesen werden. Die Datei ist möglicherweise beschädigt oder hat ein nicht unterstütztes Format.",
    by: "Von",
    cover: "Titelbild",
    type: "Typ",
    relative_path: "Relativer Pfad",
    file: "Datei",
    show_all_contacts: "Alle Kontakte anzeigen",
    messages_filter_all: "Alle",
    messages_filter_unread: "Ungelesen",
    messages_filter_awaiting_reply: "Antwort offen",
    no_matching_conversations: "Keine passenden Kontakte gefunden",
    message_sent: "Gesendet",
    message_delivered: "Zugestellt",
    message_read: "Gelesen",
    add_tag: "Tag hinzufügen",
    edit_tag: "Tag bearbeiten",
    delete_tag: "Tag löschen",
    tag_name: "Tag Name",
    confirm_delete_tag: "Bist du sicher, dass du diesen Tag löschen möchtest? Er wird überall entfernt.",
    create_new_tag: "Neuen Tag erstellen",
    count_selected: "{{count}}× ausgewählt",
    tags: "Tags",
    no_one_off_events: "Zurzeit sind keine einmaligen Termine angekündigt.",
    see_regular_dates: "Regelmäßige Termine ansehen",
    regular_dates: "Regelmäßig",
    dates_count: "{{count}} Termine",
    one_date: "1 Termin",
    rhythm_every_other_week: "alle 2 Wochen",
    rhythm_monthly: "{{nth}} {{weekday}} im Monat",
    ordinal_1: "1.",
    ordinal_2: "2.",
    ordinal_3: "3.",
    ordinal_4: "4.",
    ordinal_last: "letzter",
    next_date: "nächster {{date}}",
    no_regular_dates: "Zurzeit gibt es keine regelmäßigen Termine.",
    no_events_this_year: "In diesem Jahr ist nichts angekündigt.",
    next_event_label: "Nächste Veranstaltung",
    category_label: "Kategorie",
    show_category: "Anzeigen",
    running_this_day: "Läuft an diesem Tag",
    program_automatic: "Nächste Veranstaltungen automatisch",
    program_automatic_hint: "Dieser Block zeigt die nächsten Veranstaltungen aus dem Kalender. Neue erscheinen nach dem Speichern.",
    allow_member_collection_images: "Mitglieder dürfen Bilder in ihre eigenen Sammlungen hochladen",
    allow_member_collection_images_description: "Für Künstlerinnen und Künstler, die ihre Seite selbst pflegen: Sie laden ihre Werke hoch und schreiben Titel und Angaben dazu. Seiten, Veranstaltungen und Einstellungen bleiben den Admins vorbehalten.",
    upload_pictures: "Bilder hochladen",
    uploading_n_of_m: "Wird hochgeladen … {{n}} von {{m}}",
    picture_title: "Titel",
    picture_details: "Jahr, Technik, Maße",
    upload_failed_named: "{{name}} konnte nicht hochgeladen werden.",
    program: "Programm",
    calendar_view: "Ansicht",
    all_categories: "Alle",
    running_now: "Läuft gerade",
    coming_up: "Demnächst",
    load_year: "{{year}} laden",
    events_count: "{{count}} Veranstaltungen",
    one_event: "1 Veranstaltung",
    no_upcoming_events: "Zurzeit ist nichts angekündigt.",
    running_this_month: "Läuft in diesem Monat",
    running_this_week: "Läuft in dieser Woche",
    running_this_year: "Ausstellungen und mehrtägige Veranstaltungen",
    new_event_on_day: "Veranstaltung",
    more_events: "{{count}} weitere",
    no_events_this_day: "An diesem Tag ist nichts angekündigt.",
    no_events_this_week: "In dieser Woche ist nichts angekündigt.",
    no_events_this_month: "In diesem Monat ist nichts angekündigt.",
    no_events_in_month_short: "—",
    to_program: "Zum Programm",
    calendar_week_short: "KW",
    not_public: "Nicht öffentlich",
    event_details: "Details",
    previous_period: "Zurück",
    next_period: "Weiter",
    insert: "Einfügen",
    from_library: "Aus der Bibliothek …",
    new_entry_of_type: "Neu anlegen",
    block: "Block",
    tags_of_entry: "Tags dieses Eintrags",
    first_colored_tag_note: "Das erste Tag mit Farbe gibt dem Eintrag seine Farbe, zum Beispiel im Kalender.",
    search_or_create_tag: "Tag suchen oder neu anlegen",
    manage_tags_and_colors: "Tags und Farben verwalten",
    move_to_front: "Nach vorne",
    no_tags_yet: "Noch keine Tags",
    no_color: "Keine Farbe",
    rename: "Umbenennen",
    tags_settings_help: "Ein Tag mit Farbe ist eine Kategorie: Es färbt Einträge im Kalender und im Programm und erscheint als Filter. Die Farben kommen aus den Farbsätzen oben. Änderungen an Tags gelten sofort.",
    tag_color: "Farbe",
    internal: "Intern",
    admins_only_visibility: "Nur für Admins sichtbar",
    by_signing_up_you_agree_to_the_privacy_policy_and_terms_and_conditions: "Durch die Registrierung erklären Sie sich mit unserer <a href='{{privacy_policy}}' target='_blank' class='underline'>Datenschutzerklärung</a> und unseren <a href='{{terms_and_conditions}}' target='_blank' class='underline'>Nutzungsbedingungen</a> einverstanden.",
    by_signing_up_you_agree_to_the_privacy_policy: "Durch die Registrierung erklären Sie sich mit unserer <a href='{{privacy_policy}}' target='_blank' class='underline'>Datenschutzerklärung</a> einverstanden.",
    by_signing_up_you_agree_to_the_terms_and_conditions: "Durch die Registrierung erklären Sie sich mit unseren <a href='{{terms_and_conditions}}' target='_blank' class='underline'>Nutzungsbedingungen</a> einverstanden.",
    field_is_required: "{{field}} ist erforderlich",
    custom_field_label: "Feldbezeichnung",
    custom_field_placeholder: "Platzhaltertext",
    custom_field_type: "Feldtyp",
    custom_field_required: "Pflichtfeld",
    custom_field_options: "Optionen",
    add_option: "Option hinzufügen",
    delete_field: "Feld löschen",
    confirm_delete_field_message: "Sind Sie sicher, dass Sie dieses Feld löschen möchten? Alle von Benutzern in diesem Feld übermittelten Daten werden nach dem Speichern der Einstellungen dauerhaft gelöscht.",
    custom_form_fields: "Benutzerdefinierte Formularfelder",
    signup_form_fields: "Anmeldeformular Felder",
    configure_custom_fields_description: "Konfiguriere zusätzliche Felder, die von Benutzern bei der Anmeldung ausgefüllt werden. Die Felder Name und E-Mail sind immer erforderlich.",
    no_custom_fields_configured: "Keine benutzerdefinierten Felder konfiguriert. Klicke auf \"Feld hinzufügen\", um dein erstes benutzerdefiniertes Feld zu erstellen.",
    add_field: "Feld hinzufügen",
    field_id: "Feld-ID",
    field_type_text: "Einzeiliger Text",
    field_type_longtext: "Mehrzeiliger Text",
    field_type_float_number: "Dezimalzahl",
    field_type_integer_number: "Ganzzahl",
    field_type_checkbox: "Checkbox",
    field_type_select: "Auswahlliste",
    field_type_country: "Länderauswahl",
    field_type_phone: "Telefonnummer",
    field_type_weblink: "Website-URL",
    countries: "Länder",
    languages: "Sprachen",
    common_sources: "Gemeinsame Quellen",
    gender_pronouns: "Pronomen",
    field_must_be_valid_number: "{{field}} muss eine gültige Zahl sein",
    field_must_be_valid_integer: "{{field}} muss eine ganze Zahl sein",
    field_must_be_valid_phone_number: "{{field}} muss eine gültige Telefonnummer sein",
    field_must_be_valid_url: "{{field}} muss eine gültige URL sein",
    save_changes: "Änderungen speichern",
    increment_value: "Wert erhöhen",
    decrement_value: "Wert verringern",
    page_plural: "Seiten",
    collection_plural: "Sammlungen",
    event_plural: "Veranstaltungen",
    image_plural: "Bilder",
    access_forbidden_title: "Du hast keinen Zugriff",
    access_forbidden_description: "Dieser Inhalt ist eingeschränkt. Wenn du Zugriff benötigst, melde dich mit einem Konto an, das über die erforderliche Rolle verfügt, oder kontaktiere uns.",
    custom_fields: "Benutzerdefinierte Felder",
    user_details: "Benutzerkontodetails",
    assets: "Dateien",
    asset: "Asset",
    upload: "Hochladen",
    path_prefix_hint: "Pfad-Präfix (ohne führende und nachfolgende Schrägstriche)",
    remaining: "Verbleibend",
    no_assets_found: "Keine Assets gefunden",
    protected: "Geschützt",
    size: "Größe",
    confirm_delete_selected_assets: "Bist du sicher, dass du diese {{count}} Assets löschen willst? Dies kann nicht rückgängig gemacht werden.",
    error_deleting_assets: "Fehler beim Löschen von Assets: {{error}}",
    saving: "Speichern …",
    
    // Analytics
    this_page: "Diese Seite",
    site_total: "Gesamt",
    views: "Aufrufe",
    relevance: "Relevanz",
    peak: "Spitze",
    no_data: "Keine Daten",
    no_peak_data: "Nicht genug Daten",
    last_n_days: "Letzte {{days}} Tage",
    analytics_n_days: "{{days}} Tage",
    analytics_visits: "Besuche",
    analytics_trend: "zu Vormonat",
    analytics_sources: "Quellen",
    analytics_campaigns: "Kampagnen",
    analytics_exits: "Ausgänge",
    analytics_exit_mail: "E-Mail",
    referrer_direct: "direkt",
    referrer_internal: "intern",
    referrer_external: "extern",
    referrer_search: "Suche",
    referrer_ai: "K.I.",
    referrer_social: "Social",
    
    // Canvas toolbars & entry selection
    move_up: "Nach oben",
    move_down: "Nach unten",
    move_left: "Nach links",
    move_right: "Nach rechts",
    add_block_after: "Block danach einfügen",
    add_block_before: "Block davor einfügen",
    remove_block: "Block entfernen",
    more_actions: "Weitere Aktionen",
    table_view: "Tabellenansicht",
    grid_view: "Kachelansicht",
    view_mode: "Ansicht",
    create_new: "Neu erstellen",
    field_visibility: "Sichtbare Felder",
    embeds: "Einbettungen",
    no_entries_selected: "Keine Beiträge ausgewählt",
    add_selected_entries: "{{count}} Beiträge hinzufügen",
    add_selected_images: "{{count}} Bilder hinzufügen",
    add_selected_entry: "Beitrag hinzufügen",
    browse_entries: "Beiträge durchsuchen",
    browse_entries_description: "Alle Beiträge durchsuchen und auswählen",
    browse_images: "Bilder durchsuchen",
    link_to_entry: "Eintrag verlinken",
    link_to_entries: "{{count}} Einträge verlinken",
    select_entries_to_add: "Beiträge zum Hinzufügen auswählen",
    untitled: "Ohne Titel",
    insert_new_entry: "Beitrag erstellen",
    block_fields: "Block Felder",
    entry_preview_fields: "Beitragsfelder",
    entry_preview_input_placeholder: "Button- oder Linktext",
    clear_selection: "Auswahl aufheben",
    change_visibility: "Sichtbarkeit ändern",
    count_entry_selected: "{{count}} Eintrag ausgewählt",
    count_entries_selected: "{{count}} Einträge ausgewählt",

    // Stickers
    sticker_add: "Sticker hinzufügen",
    sticker_edit: "Sticker bearbeiten",
    sticker_anchor: "Verankerung",
    sticker_anchor_image: "Bild",
    sticker_anchor_block: "Block",
    sticker_anchor_text: "Textfelder",
    sticker_area: "Ankerpunkt",
    sticker_size: "Größe (px)",
    sticker_rotation: "Drehung (°)",
    sticker_offset: "Versatz",
    sticker_label: "Beschriftung",
    sticker_label_placeholder: "z.B. Jetzt anrufen",
    sticker_link: "Link",
    sticker_replace_image: "Bild ersetzen",
    contents: "Inhalte",
    account_menu: "Kontomenü",
    alignment: "Ausrichtung",
    basic_blocks: "Grundbausteine",
    blocked: "Gesperrt",
    browse: "Inhalte durchsuchen",
    toggle_navigation: "Navigation ein- oder ausblenden",
    open: "Öffnen",
    read_by_user: "Gelesen am",
    report: "Melden",
    transparent: "Transparent",
    unknown: "Unbekannt",
    yes: "Ja",
    no: "Nein",
    future: "Später",
    play_video_for_title: "Video {{title}} abspielen",
    pause_video_for_title: "Video {{title}} pausieren",
    unsaved_changes_warning: "Es gibt ungespeicherte Änderungen. Trotzdem schließen?",
    error_deleting_entries: "Fehler beim Löschen der Beiträge: {{error}}",
    error_updating_entries_visibility: "Fehler beim Ändern der Sichtbarkeit: {{error}}",
    failed_to_create_collection: "Die Sammlung konnte nicht erstellt werden.",
    scale_factor: "Skalierungsfaktor",
    select_control_surface: "Oberfläche wählen",
    select_size: "Größe wählen",
    select_weight: "Schriftstärke wählen",
    uppercase: "Großbuchstaben",
    lowercase: "Kleinbuchstaben",
    capitalize: "Wortanfänge groß",
    xxs: "XXS",
    xs: "XS",
    sm: "S",
    md: "M",
    lg: "L",
    xl: "XL",
    xxl: "XXL",
    xxxl: "XXXL",
    address: "Adresse",
    tel: "Telefon",
    message: "Nachricht",
    chat: "Chat",
    login: "Anmelden",
    stories: "Geschichten",
    news: "Neuigkeiten",
    posts: "Beiträge",
    schedule: "Programm",
    appointments: "Termine",

    // CUSTOM_CODE_STARTS (PATCH_WORK)
    available_credits: "Verbleibendes Guthaben",
    available_quantity: "Verfügbare Menge",
    capacity_can_only_be_increased_in_booking_window: "Nur Kapazität kann bearbeitet werden (um Überbuchung zu vermeiden)",
    base_price: "Grundpreis",
    book_as: "Buchen als",
    book_now: "Jetzt buchen",
    booking_this_week: "Buchung dieser Woche",
    booking_type: "Buchungstyp",
    bookings_for_month: "Buchungen für {{month}}",
    bookings_this_week: "Buchungen diese Woche",
    bookings: "Buchungen",
    booking: "Buchung",
    change_resource: "Ressource ändern",
    credits_used: "Guthaben verbraucht",
    current_year: "Aktuelles Jahr",
    unavailable_for_booking: "Dieser Zeitraum ist für Buchungen derzeit nicht verfügbar",
    daily: "Täglich",
    desk: "Schreibtisch",
    discounted_price: "Mitgliedspreis",
    equipment_plural: "Ausstattung",
    equipment: "Ausstattung",
    fixed_desk: "Fixed Desk",
    fixed_desk_plural: "Fixed Desks",
    flex_desk: "Flex Desk",
    flex_desk_plural: "Flex Desks",
    free_using_credits: "Kostenlos",
    addon: "Addon",
    addon_plural: "Addons",
    half_hourly: "Halbstündlich",
    max_price: "Maximaler Preis",
    meeting_room_plural: "Meeting Räume",
    meeting_room: "Meetingraum",
    membership_savings: "Mitgliedsrabatte",
    credits_in_month: "Guthaben für {{month}}",
    monthly: "Monatlich",
    new_prices_from: "Neue Preise ab",
    next_year: "Nächstes Jahr",
    no_access: "Kein Zugriff",
    office_plural: "Büros",
    office: "Büro",
    previous_year: "Vorheriges Jahr",
    price_breakdown: "Preisaufschlüsselung",
    price_from: "Ab {{from}}",
    prices_and_capacities: "Preise und Kapazitäten",
    pricing_invalid: "Die Preise für mindestens eine Ressource sind ungültig. Bitte überprüfe die Preise und versuche es erneut.",
    pricing_locked: "Bereits gesetzte Preise können nicht mehr verändert werden.",
    pricing_method: "Preisgestaltung",
    pricing_not_configured: "Preisgestaltung nicht konfiguriert",
    pricing_will_lock: "Die Preise werden nach dem Speichern gesperrt und können nicht mehr verändert werden.",
    resource_label: "Ressource",
    resource_label_plural: "Ressourcen",
    resource_pricing_invalid: "Die Preise für mindestens eine Ressource sind unvollständig. Bitte fülle alle Felder aus.",
    resource: "Ressource",
    resource_type: "Ressourcen Typ",
    save_pricing_failed: "Das Speichern der Preise schlug fehl. Bitte versuche es erneut. Falls das Problem weiterhin besteht, wende dich bitte an den Support.",
    select_resource_type: "Wähle den Ressourcen Typ",
    subscription: "Abonnement",
    this_month: "Dieser Monat",
    total_for_month: "Gesamt für {{month}}",
    total_to_pay: "Gesamt zu zahlen",
    reserve_with_one_click: "Reserviere mit einem Klick",
    reservations: "Reservierungen",
    reservations_for_authenticated_user: "Meine Reservierungen ({{name}})",
    reservations_for_current_user: "Reservierungen für <q>{{name}}</q>",
    how_to_book_as_representative: "Du kannst für dich oder dein Team reservieren. Klicke einfach auf dein Avatar, um die Person oder das Unternehmen auszuwählen, für die du reservieren möchtest.",
    unavailable: "Nicht verfügbar",
    outside_business_hours: "Außerhalb der Geschäftszeiten",
    credit_allowance: "Guthaben",
    discount_percentage: "Rabatt in %",
    business_customer_vat_notice: "Alle Preise sind Nettopreise und verstehen sich zuzüglich der gesetzlichen Mehrwertsteuer, sie richten sich ausschließlich an Unternehmer, Selbstständige (§ 14 BGB) und juristische Personen des öffentlichen Rechts.",
    click_to_book: "Wähle freie Slots aus, einzeln oder durch Ziehen über mehrere. Gebucht wird erst, wenn du unten bestätigst.",
    click_to_cancel: "Zum Stornieren wähle deine Buchung aus und bestätige unten.",
    booking_sheet_label: "Auswahl bestätigen",
    booking_sheet_move: "Leiste verschieben",
    booking_sheet_toggle: "Details ein- oder ausblenden",
    booking_unit_slot: "Slot",
    booking_unit_slots: "Slots",
    booking_unit_slot_cancel: "Slot stornieren",
    booking_unit_slots_cancel: "Slots stornieren",
    booking_unit_desk: "Tisch",
    booking_unit_desks: "Tische",
    booking_unit_desk_cancel: "Tisch stornieren",
    booking_unit_desks_cancel: "Tische stornieren",
    booking_days: "{{count}} Tage",
    booking_storno: "{{count}} Storno",
    booking_stornos: "{{count}} Stornos",
    booking_mini_selected: "ausgewählt",
    booking_mini_cancel: "zum Stornieren ausgewählt",
    booking_mini_changes: "Änderungen ausgewählt",
    booking_book: "Buchen",
    booking_cancel: "Stornieren",
    booking_confirm: "Bestätigen",
    booking_book_count: "{{count}} {{unit}} buchen",
    booking_cancel_count: "{{count}} {{unit}} stornieren",
    booking_book_and_cancel: "{{book}} buchen · {{cancel}} stornieren",
    booking_working_book: "Wird gebucht …",
    booking_working_cancel: "Wird storniert …",
    booking_working_both: "Wird gespeichert …",
    booking_receipt_booked: "Gebucht",
    booking_receipt_cancelled: "Storniert",
    booking_receipt_changed: "Änderungen gespeichert",
    booking_cancelled_suffix: "storniert",
    booking_confirmation_email_to: "Bestätigung per E-Mail an {{email}}",
    booking_invoice_to: "Rechnung an {{name}}",
    booking_internal: "Intern (keine Abrechnung)",
    booking_estimate: "Voraussichtlich",
    booking_estimate_credits: "nach Abzug von {{amount}} Guthaben",
    booking_estimate_day_max: "höchstens {{amount}} pro Tag",
    booking_estimate_month_max: "{{price}} pro Tag, höchstens {{max}} im Monat",
    booking_estimate_day_price: "{{price}} pro Tag",
    booking_cap_reached: "(erreicht)",
    booking_cancellation_free: "Stornierung · kostenlos",
    booking_free_cancellation_until: "Kostenlos stornierbar bis {{time}}",
    booking_starts_soon_no_cancel: "Beginnt in weniger als {{minutes}} Minuten: nach dem Buchen nicht mehr stornierbar.",
    booking_starts_soon_short: "Beginnt gleich: nicht mehr stornierbar",
    booking_clear_selection: "Auswahl aufheben",
    booking_done: "Fertig",
    booking_error_changed: "Die Belegung hat sich inzwischen geändert. Die Ansicht ist aktualisiert.",
    booking_legend_selected: "Ausgewählt, noch nicht gebucht",
    booking_legend_selected_cancel: "Zum Stornieren ausgewählt, noch nicht storniert",
    booking_confirm_below: "Gebucht oder storniert wird erst, wenn du unten bestätigst.",
    booking_discard_selection: "Deine Auswahl ist noch nicht bestätigt. Verwerfen?",
    cancel_free_until_minutes_before_booking: "Storniere kostenlos bis {{minutes}} Minuten vor Beginn der Buchung.",
    slot_symbols_explained: "Symbole erklärt",
    how_to_reserve_a_meeting_room: "Wie du einen Meetingraum reservierst",
    how_to_book_a_desk: "Wie du einen Tisch reservierst",
    previous_week: "Vorherige Woche",
    next_week: "Nächste Woche",
    days_with_bookings: "Tage mit Buchungen",
    click_any_date_to_book: "<b>Buchen:</b> Klicke auf das Plus-Symbol",
    book_multiple_desks_per_team_member: "<b>Team Buchungen:</b> Du kannst mehrere Tische gleichzeitig für dein Team buchen.",
    cancel_up_to_1_day_before_your_reservation: "<b>Stornieren:</b> Du kannst deine Reservierung bis einen Tag davor kostenlos stornieren.",
    active_subscriptions: "Aktive Abonnements",
    expired_subscriptions: "Abgelaufene Abonnements",
    selected_month_is_fully_booked: "Der ausgewählte Monat ist vollständig gebucht.",
    start: "Start",
    end: "Ende",
    subscription_by: "Abonniert von",
    book_new_subscription: "Neues Abonnement buchen",
    cancellation_notice_period: "Kündigungsfrist",
    cancel_subscription: "Abonnement kündigen",
    cancel_subscription_with_id: "Abonnement #{{subscription}} kündigen",
    change_subscription_with_id: "Abonnement #{{subscription}} ändern",
    select_end_date: "Enddatum auswählen",
    select_start_date: "Startdatum auswählen",
    at_end_of_month: "zum Monatsende",
    months: "Monate",
    subscription_autorenewal: "Dein Abonnement wird automatisch verlängert.",
    uncancel_subscription: "Kündigung zurücknehmen",
    when_do_you_want_to_start: "Wann möchtest du starten?",
    half_hour: "30 min",
    no_end_date: "Kein Enddatum",
    new_subscription: "Neues Abonnement",
    manage_subscriptions: "Abonnements verwalten",
    manage_bookings: "Buchungen verwalten",
    renews_automatically: "Wird automatisch verlängert",
    meeting_room_confirmation_subject: "Meetingraum Buchung bestätigt: {{date}}",
    meeting_room_reminder_subject: "Erinnerung für Meetingraum Buchung: {{date}}",
    meeting_room_confirmation_intro: "Deine Meetingraum Buchung wurde bestätigt.",
    meeting_room_reminder_today: "Du hast {{count}} {{bookings}} für heute ({{date}}):",
    meeting_room_reminder_tomorrow: "Du hast {{count}} {{bookings}} für morgen ({{date}}):", 
    meeting_room_booking_date_and_time: "{{room_name}} <br>am {{booking_date}} <br>von <time datetime=\"{{start_time_iso}}\">{{start_time}}</time> bis <time datetime=\"{{end_time_iso}}\">{{end_time}}</time> <em>({{hours}}h:{{minutes}}min)</em>",
    meeting_room_reminder_footer: "Bitte komme pünktlich und hinterlasse den Raum ordentlich für die nächsten Mitglieder. <br>Vielen Dank!",
    alert_cancellation_time_limit: "Diese Buchung kann nicht mehr storniert werden: Stornierungen sind nur bis {{minutes}} Minuten vor Beginn möglich.",
    alert_insufficient_time_remaining: "Dieser Slot kann nicht gebucht werden, da weniger als 15 Minuten verbleiben.",
    alert_slot_unavailable: "Dieser Slot ist nicht verfügbar, da er bereits von einem anderen Mitglied gebucht wurde.",
    alert_booking_not_authorized: "Du bist nicht berechtigt, diese Buchung vorzunehmen.",
    alert_generic_error: "Bei der Verarbeitung deiner Anfrage ist ein Fehler aufgetreten. Bitte versuche es erneut.",
    daily_booking_new_confirmation_intro: "Folgende neue {{resource_type}} Buchungen wurden soeben bestätigt:",
    daily_booking_monthly_overview_subject: "Bestätigung deiner {{resource_type}} Buchungen",
    daily_booking_entry: "{{date}}: {{count}}× {{resource}}",
    daily_booking_footer: "Wir freuen uns auf dich!",
    booking_cancellation_subject: "Stornierung bestätigt",
    booking_cancellation_intro: "Folgende Buchungen wurden storniert:",
    booking_cancellation_room_entry: "{{date}}: {{room_name}}, {{start_time}}–{{end_time}}",
    booking_cancellation_footer: "Stornierte Buchungen werden nicht berechnet.",
    daily_booking_reminder_subject: "Erinnerung für {{resource_type}} Buchung: {{date}}",
    daily_booking_reminder_intro: "Nur zur Erinnerung: Morgen, {{date}}, erwarten wir dich für deine {{resource_type}} Buchung.",
    daily_booking_calendar_for_month: "{{resource_type}} Buchungsübersicht für {{month}}",
    subscription_confirmation_subject: "Abonnement Bestätigung: {{name}}",
    subscription_confirmation_intro: "Du hast das Abonnement <strong>{{resource_name}}</strong> erfolgreich gebucht:",
    subscription_booking_details: "{{resource_name}} ab {{start_date}}",
    subscription_confirmation_footer: "Vielen Dank für deine Buchung!",
    error_not_authorized: "Du bist nicht berechtigt, diese Aktion durchzuführen.",
    error_subscription_not_available_for_start_period: "Dieses Abonnement ist für den gewählten Startzeitraum leider nicht mehr verfügbar.",
    error_database_error: "Bei der Verarbeitung deiner Anfrage ist ein Fehler aufgetreten. Bitte versuche es erneut.",
    error_unknown: "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es später erneut.",
    subscription_booked_successfully: "Abonnement <strong>{{resource_name}}</strong> erfolgreich für <strong>{{user_name}}</strong> gebucht",
    alert_booked_by_me_in_past: "Dieser Slot liegt in der Vergangenheit und kann nicht mehr storniert werden.",
    subscription_booked_for: "Dieses Abonnement wurde für <strong>{{name}}</strong> gebucht und wird über dessen Rechnung verrechnet.",
    days: "Tage",
    how_are_you_planning_to_use_website: "Wie möchtest du {{name}} nutzen?",
    sign_up_for_personal_use_title: "Für persönliche Nutzung",
    sign_up_for_personal_use_description: "Buche als Freiberufler oder Selbstständiger auf eigenen Namen und auf eigene Rechnung.",
    sign_up_for_personal_use_next_step_info: "Bitte gib im nächsten Schritt deine Rechnungsadresse und Zahlungsmethode an.",
    sign_up_for_joining_team_title: "Meinem Team beitreten", 
    sign_up_for_joining_team_description: "Du möchtest Buchungen über dein Firmenkonto vornehmen",
    sign_up_for_joining_team_next_step_info: "Nachdem du die Registrierung abgeschlossen hast, kontaktiere die Ansprechperson deiner Firma, und bitte sie für deinen Account <span class='-bold'>{{email}}</span> um Team-Zugriff.",
    sign_up_for_new_business_title: "Neues Unternehmen",
    sign_up_for_new_business_description: "Erstelle ein neues Firmenkonto und lade deine Teammitglieder ein.",
    sign_up_for_new_business_next_step_info: "Bitte gib im nächsten Schritt deine Rechnungsadresse und Zahlungsmethode an, damit dein Team über das Firmenkonto buchen kann.",
    complete_sign_up: "Registrierung abschließen",
    continue_to_stripe: "Rechnungsdaten festlegen",
    billing: "Abrechnung",
    city: "Stadt",
    country: "Land",
    address_line1: "Adresszeile 1",
    address_line2: "Adresszeile 2",
    postal_code: "Postleitzahl",
    payment_method_set: "Zahlungsmethode hinterlegt",
    billing_portal: "Abrechnungsportal",
    no_payment_method_set_required_for_booking: "Keine Zahlungsmethode hinterlegt. Diese ist erforderlich für Buchungen auf eigene Rechnung!",
    billing_address_not_set: "Rechnungsadresse unvollständig. Eine vollständige Adresse ist für die Rechnungsstellung erforderlich.",
    billing_address: "Rechnungsadresse",
    change_billing_address: "Rechnungsadresse ändern",
    manage_payment_method: "Zahlungsmethode verwalten",
    cancelled_at: "Gekündigt am",
    book_rooms_and_times: "Räume & Zeiten",
    keep_track_of_your_bookings: "Behalte den Überblick über deine Termine.",
    book_with_one_click: "Buche mit einem Klick.",
    add_payment_details: "Zahlungsmethode hinzufügen",
    add_billing_address: "Rechnungsadresse hinzufügen",
    need_help_with_billing_title: "Hilfe bei der Abrechnung benötigt?",
    need_help_with_billing_description: "Wenn du Hilfe bei der Rechnungsstellung benötigst, hilft dir unser Support-Team gerne weiter.",
    contact_support: "Support kontaktieren",
    book_and_pay_now: "Jetzt Zahlungspflichtig Buchen",
    plus_vat: "zzgl. USt.",
    confirm_your_booking: "Bestätige deine Buchung",
    booking_for: "Buchung für",
    booking_on_invoice_of: "Buchung auf Rechnung von",
    on_count_of_day: "an {{count}} Tag",
    on_count_of_days: "an {{count}} Tagen",
    subscriptions: "Abonnements",
    fully_booked: "Vollständig gebucht",
    add_missing_payment_details: 'Um zu buchen, füge erst eine <a class="underline" href="{{href}}">Zahlungsmethode</a> hinzu.',
    add_missing_billing_address: 'Um zu buchen, füge erst eine <a class="underline" href="{{href}}">Rechnungsadresse</a> hinzu.',
    add_missing_payment_details_or_switch_account: 'Um zu buchen, füge erst eine <a class="underline" href="{{href}}">Zahlungsmethode</a> hinzu oder wechsle zu deinem Team / Firmenkonto.',
    book_on_behalf_of_company_team_member_hint: 'Wenn du im Namen deiner Firma buchen möchtest, kontaktiere bitte die Ansprechperson deiner Firma und bitte sie, deine E‑Mail <span class="text-3">{{email}}</span> im Firmenkonto für den Team-Zugriff freizuschalten.',    pricing_and_capacity: "Preise & Kapazitäten",
    contact_us_for_custom_requests: "Kontaktiere uns für individuelle Anfragen",
    login_and_book: "Anmelden & Buchen",
    no_fitting_month_found: "Kein passender Monat gefunden?",
    new_subscription_booked: "Neues Abonnement \"{{resource_name}}\" von {{customer_name}} gebucht",
    view_subscriptions: "Abonnements ansehen",
    custom_price: "Angepasster Preis",
    booked_by_user_details: "Gebucht von {{name}} <br />{{email}}",
    new_meeting_room_booking_email_subject_admin: "Neue Meetingraum Buchung von {{user_name}} ({{user_email}}) am {{date}}",
    new_daily_booking_email_subject_admin: "Neue Buchung für {{resource_name}} von {{user_name}} ({{user_email}})",
    booking_cancellation_subject_admin: "Stornierung von {{user_name}} ({{user_email}})",
    booking_cancellation_admin_intro: "Folgende Buchungen wurden soeben storniert:",
    bookings_for_day: "Buchungen für  {{day}}",
    no_bookings_for_this_day: "Keine Buchungen für diesen Tag",
    add_internal_booking_notes: "Füge interne Notizen zu den Buchungen hinzu (nur für Admins sichtbar)",
    last_update_by: "Zuletzt aktualisiert von {{name}}",
    offices_desks_and_more: "Büros, Schreibtische und mehr",
    bookings_on: "Buchungen am",
    no_bookings_on_day: "Keine Buchungen am {{date}}",
    locks_tooltip: "Gib die Schloss-IDs für die Zugangspunkte der Ressource ein. Diese müssen genau mit den von der Zugangskontrolle verwendeten IDs übereinstimmen.",
    add_lock: "Schloss hinzufügen",
    locks: "Schlösser",
    lock_id: "Schloss-ID",
    room_id: "Raumnummer",
    no_lock_selected: "Kein Schloss ausgewählt",
    no_lock_selected_hint: "Wähle ein Loxone-Schloss aus.",
    unknown_room: "Unbekannter Raum",
    unknown_lock: "Unbekanntes Schloss",
    select_lock: "Schloss auswählen",
    sync_loxone_locks: "Loxone-Schlösser synchronisieren",
    syncing_loxone_locks: "Synchronisiere Loxone-Schlösser...",
    loxone_lock_sync_ready: "Schlosskatalog synchronisiert.",
    loxone_lock_sync_fallback_active: "Live-Sync fehlgeschlagen, verwende lokale Strukturdatei.",
    loxone_lock_sync_cached_data: "Live-Sync fehlgeschlagen, verwende zwischengespeicherte Daten.",
    loxone_lock_catalog_load_failed: "Loxone-Schlosskatalog konnte nicht geladen werden.",
    loxone_lock_unknown_warning: "Dieses Schloss ist nicht im aktuellen Loxone-Katalog vorhanden.",
    loxone_lock_assigned_elsewhere: "Wird auch von einer anderen Ressource verwendet.",
    loxone_lock_assigned_elsewhere_to: "Wird auch verwendet von: {{resources}}.",
    loxone_lock_assigned_elsewhere_short: "Auch von anderer Ressource verwendet.",
    loxone_lock_assigned_elsewhere_to_short: "Auch verwendet von: {{resources}}",
    loxone_lock_reassignment_notice: "Schlösser können von mehreren Ressourcen verwendet werden.",
    room_id_not_set: "Keine Raumnummer gesetzt",
    lock_id_not_set: "Keine Schloss-ID gesetzt",
    access_code: "Zugangscode",
    access_code_generation_failed: "Zugangscode konnte nicht generiert werden. Bitte kontaktiere den Support.",
    meeting_room_booking_admin_intro: "Folgende neue Meetingraum Buchungen wurden soeben bestätigt:",
    max_individual_daily_bookings_per_day: "Maximale Buchungen pro Tag",
    max_individual_daily_bookings_per_day_tooltip: "Maximale Anzahl an Buchungen, die ein einzelner Benutzer pro Tag vornehmen kann. Leer lassen für unbegrenzt.",
    max_individual_daily_bookings_per_month: "Maximale Buchungen pro Monat",
    max_individual_daily_bookings_per_month_tooltip: "Maximale Anzahl an Buchungen, die ein einzelner Benutzer pro Monat vornehmen kann. Leer lassen für unbegrenzt.",
    max_individual_daily_bookings_per_day_reached: "Du hast das tägliche Buchungslimit von {{max}} erreicht.",
    max_individual_daily_bookings_per_month_reached: "Du hast das monatliche Buchungslimit von {{max}} erreicht.",
    open_day: "Open Day",
    booking_count: "Getätigte Buchungen",
    cancellation_notice: "Laufzeit: monatlich, Mindestlaufzeit: {{months}} {{unit}}",
    credit_allowance_for_meeting_room: "Guthaben für Meetingraum Buchungen",
    discount_for_meeting_room: "Rabatt für Meetingraum Buchungen",
    subscriber_benefits: "Deine Vorteile als Abonnent",
    welcome_name: "Willkommen, {{name}}!",
    your_meeting_is_in_progress: "Deine Buchung hat begonnen. Nutze deinen Code aus der Buchungs-Email, um den Raum zu betreten.",
    your_meeting_starts_soon: "Deine Buchung startet bald. Nutze deinen Code aus der Buchungs-Email, um den Raum zu betreten.",
    meeting_room_available: "Meetingraum verfügbar",
    book_via_app: "Buche über unsere App",
    good_to_know: "Gut zu wissen",
    billing_log: "Abrechnungs Protokoll",
    invoice_generation_status: "Rechnungserstellungsstatus",
    error_detected_requires_manual_intervention: "Fehler erkannt - erfordert manuelles Eingreifen",
    error_details: "Fehlerdetails",
    retry_invoice_generation: "Rechnungserstellung wiederholen",
    unbilled_bookings_pending: "Ausstehend",
    meeting_room_bookings: "Meetingräume",
    daily_bookings_flex_desks: "Flex Desks",
    recent_invoices: "Rechnungen",
    billed_meeting_room_days: "Meetingräume (abgerechnet)",
    billed_daily_booking_months: "Flex Desks (abgerechnet)",
    period: "Zeitraum",
    slots: "Slots",
    stripe_invoice: "Stripe Rechnung",
    price_basis: "Preisbasis",
    invoice: "Rechnung",
    notice_terms_and_conditions: "Mit der Buchung erklären Sie sich mit unseren <a href='{{terms_and_conditions}}' target='_blank' class='underline'>Nutzungsbedingungen</a> einverstanden.",
    // CUSTOM_CODE_ENDS (PATCH_WORK)
  },
  // END — GERMAN

  // START — ENGLISH
  en: {
    slideshow: "Slideshow",
    entry_label_event_plural: "Events",
    entry_label_image_plural: "Media",
    entry_label_page_plural: "Pages",
    entry_label_collection_plural: "Collections",
    entry_label_event: "Event",
    entry_label_image: "Image & Short Video",
    entry_label_page: "Page",
    entry_label_collection: "Collection",
    add_an_image: "Add an Image or Video Loop.",
    drag_and_drop: "Drag & Drop",
    add_block: "Add Block",
    add_entries: "Add Entries",
    add_image: "Add Image",
    add: "Add",
    align: "Align",
    align_left: "Left",
    width_fixed_by_layout: "Width is fixed by this layout",
    harmonise_widths: "Harmonise widths",
    harmonise_widths_hint: "Set every block on this page to this width",
    harmonised_widths: "{{count}} blocks set to {{width}}",
    harmonised_widths_with_skipped: "{{count}} blocks set to {{width}}, {{skipped}} left as they are",
    track_inner: "Narrow",
    track_extended_1: "Medium",
    track_extended_2: "Wide",
    track_flex: "Extra wide",
    track_full: "Full bleed",
    align_center: "Centre",
    align_right: "Right",
    all_day: "All day",
    until: "until",
    since: "since",
    all: "All",
    articles: "Articles",
    aspect_ratios: "Aspect Ratios",
    avatar: "Avatar",
    back: "Back",
    calendar: "Calendar",
    cancel: "Cancel",
    close: "Close",
    colors: "Colors",
    columns: "Columns",
    confirm_deletion_of_collection: "Are you sure you want to delete this collection?",
    confirm_deletion_of_page: "Are you sure you want to delete this page?",
    confirm_deletion_of_event: "Are you sure you want to delete this event?",
    confirm_deletion_of_series_base_event: "This is the base event of a series. Deleting it will automatically promote the next event in the series to become the new base event. Are you sure?",
    confirm_deletion_of_image: "Are you sure you want to delete this image?",
    continue: "Continue",
    created_at: "Created Date",
    fill_frame: "Fill frame",
    date_and_time: "Date and Time",
    date: "Date",
    day: "Day",
    decimal: "Decimal",
    decrease: "Decrease",
    delete: "Delete",
    description: "Description",
    drop_files_to_upload: "Drop Files to Upload",
    duplicate: "Duplicate",
    edit: "Edit",
    email: "Email",
    embed_entries: "Embed Entries",
    end_date: "End",
    equal_size: "Equal Size",
    event: "Event",
    events: "Events",
    fields: "Fields",
    filter: "Filter",
    font_family: "Font Family",
    word_spacing: "Word spacing",
    font_style: "Font Style",
    font_size: "Font Size",
    font_weight: "Font Weight",
    wght: "Font Weight",
    opsz: "Optical Size",
    found_entries: "Found {{count}} entries",    
    image_alt_label: "Audio Description for Blind and Low-Vision",
    image_caption_suggestion: "Tell a story about the picture",
    for_example_image_credits: "e.g. Credits",
    image: "Image",
    increment: "Increment",
    invalid_file_type: "Oops! This file type isn't supported. Please choose a different file.",
    layout: "Layout",
    layout_group_single_column: "Single Column",
    layout_group_two_column: "Two Column",
    layout_group_grid: "Grid",
    layout_group_cover: "Cover / Hero",
    layout_group_bento: "Bento",
    layout_group_editorial: "Editorial",
    layout_group_special: "Special",
    layout_group_single_column_description: "Simple single-column layouts",
    layout_group_two_column_description: "Asymmetric two-column layouts",
    layout_group_grid_description: "Equalised grid layouts with configurable columns",
    layout_group_cover_description: "Full-screen image with text overlay",
    layout_group_bento_description: "Asymmetric bento-style layouts",
    layout_group_editorial_description: "Magazine-style editorial layouts",
    layout_group_special_description: "Unique interactive layouts",
    legal_name: "Legal Name",
    letter_case: "Capitalisation",
    letter_spacing: "Letter Spacing",
    limit: "Limit",
    line_height: "Line Height",
    link: "Link",
    list: "List",
    logout: "Logout",
    max: "Max",
    menu: "Menu",
    month: "Month",
    name: "Name",
    new_entry: "New {{entry_type}}",
    new: "New",
    no_entries_found: "No more Entries found",
    none: "None",
    page_label: "Page",
    page_title: "Page Title",
    page: "Page",
    phone: "Phone",
    preview: "Preview",
    remove: "Remove",
    keep: "Keep",
    replace_image: "Replace Image",
    replace: "Replace",
    role: "Role",
    save: "Save",
    search_entries: "Search entries",
    search: "Search",
    select_an_option: "Select an option",
    select_image: "Select Image",
    selected: "Selected",
    sign_in: "Sign in",
    sign_up: "Sign up",
    start_date: "Start",
    supported_file_types_are: "Supported file types include",
    text: "Text",
    thumbnail_focus: "Safe Area & Focus",
    thumbnail: "Thumbnail",
    title: "Title",
    this_year: "This year",
    today: "Today",
    now: "Now",
    /* Heading of the first calendar list section. It holds events starting within the hour AND
       everything currently running, so "Now" reads wrong above a three-month exhibition. */
    currently: "Currently",
    typography: "Typography",
    unknown_error_occured: "An unknown error occured",
    upload_media_hint: "Upload a high-resolution image or video. For images: JPEG, PNG, HEIC, HEIF, SVG or the web-optimized AVIF format. For short videos: WEBP, APNG, MP4 or WEBM.",
    upload_single_image_hint: "Drop image here or click to upload",
    upload_image: "Upload image",
    optimizing_image: "Optimizing image",
    user: "User",
    visitor_views: "Views",
    warning_delete_aspect_ratio: "Warning: Deleting the aspect ratio \"{{aspect_ratio}}\" will cause all Blocks currently using this aspect ratio to revert to the default aspect ratio. Do you want to proceed?",
    week_number_abbreviation: "W",
    week: "Week",
    wide: "Wide",
    width: "Width",
    position: "Position",
    year: "Year",
    learn_more: "Learn more",
    insert_url: "Enter URL",
    control: "Control",
    analytics: "Analytics",
    show_all_fields: "Show all",
    hide_all_fields: "Hide all",
    selection: "Selection",
    primary_link_title: "Primary Link",
    secondary_link_title: "Secondary Link",
    add_entry: "Add entry",
    insert_or_edit_link: "Or link an entry",
    entry_previews: "Entry Previews",
    links: "Links",
    entries: "Entries",
    visibility: "Visibility",
    selected_entries: "Selected Entries",
    enter_your_email: "Enter your email.",
    login_code_sent: "Hi {{name}}, A temporary sign‑in link was sent to {{email}}.",
    check_your_email: "Check your email",
    enter_code: "Enter the code",
    login_code_incorrect: "Login code incorrect or expired. Please try again.",
    confirm_login_link: "Confirm sign-in",
    confirm_signup_link: "Confirm your email address",
    confirm_email_address: "Confirm email address",
    auth_link_invalid: "This sign-in link is invalid or has expired.",
    auth_link_recovery: "Request a new link to continue.",
    request_new_auth_link: "Request a new sign-in link",
    signup_code_incorrect: "Signup code incorrect or expired. Please try again.",
    account_blocked_title: "Can't sign in",
    account_blocked_message: "This account can't sign in right now.",
    account_blocked_message_with_support: "This account can't sign in right now. If you have questions, contact {{email}}.",
    rate_limited_message: "Please wait a minute before requesting another code.",
    go_back: "Go back",
    login_code_for: "Login code for {{domain}}",
    login_code_sent_message:
`<p>Hello {{receiver}},</p>
<p>Sign in to your account</p>
<p><a href="{{magic_link_url}}" class="email-cta">Sign in</a></p>
<p>&nbsp;</p>
<p>This link and code are valid for the next {{expiration_minutes}} minutes. If the button doesn’t work, you can use this verification code directly:</p>
<p><code class="email-code">{{code}}</code></p>
<p>&nbsp;</p>
<p>If you didn’t request this, you can safely ignore this email. For help, reply to this email.</p>
<p>Thank you,<br/>{{sender}}</p>`,
    private: "Private",
    public: "Public",
    admin: "Admin",
    member: "Member",
    search_users: "Search users",
    member_plural: "Members",
    admin_plural: "Admins",
    users: "Users",
    settings: "Settings",
    edit_user: "Edit user",
    create_user: "New user",
    new_user: "New user",
    signed_in_as: "Signed in as",
    grant_member_access_to_new_users: "Automatically assign `Member´ role to new users",
    accept: "Accept",
    become_a_member: "Become a member",
    signup_code_for: "Signup code for {{domain}}",
    signup_code: "Signup code",
    signup_code_sent: "We have sent a signup code to {{email}}. Check your emails and click the verification link, or paste the code below.",
    signup_code_sent_message:
`<p>Hello,</p>
<p>Thank you for signing up! We need to verify your email address to get you started.</p>
<p><a href="{{magic_link_url}}" class="email-cta">Verify Email Address</a></p>
<p>&nbsp;</p>
<p>If the link doesn't work, you can copy and paste the verification code directly:</p>
<p><code class="email-code">{{code}}</code></p>
<p>&nbsp;</p>
<p>Thank you,<br/>{{sender}}</p>`,
    request_login_or_signup_code: "Continue",
    continue_to_verification: "Continue to verification",
    admin_info: "Can edit this website",
    member_info: "Can access member-only posts",
    contact_info: "Can send messages",
    contact: "Contact",
    sign_up_or_log_in: "Sign up or Log in",
    paste_signup_code: "Paste signup code.",
    code_not_received: "Didn't receive the code? Please also check your spam folder first. It can take up to a few minutes to arrive.",
    code_not_received_get_assistance: "Didn't receive the code? Please also check your spam folder first. It can take up to a few minutes to arrive. Email {{email}} for assistance.",
    enter_name: "Enter name",
    complete_signup: "Complete signup",
    section: "Section",
    identity: "Identity",
    announcement: "Announcement",
    announcement_enabled: "Show announcement",
    announcement_description: "The announcement is displayed above the menu and can be dismissed by visitors. Once dismissed, it won't show again for 3 months unless you change the text. Admins won't see the announcement in editing mode. Markdown links are supported, e.g. [Learn more](/page).",
    announcement_text: "Announcement",
    announcement_placeholder: "e.g. Grand opening on March 1st! [Learn more](/events)",
    footer: "Footer",
    canvas: "Canvas",
    primary: "Primary",
    secondary: "Secondary",
    border_radius: "Border Radius",
    nav_items: "Nav Items",
    menu_placement: "Menu Variant",
    selected_images: "Selected Images",
    collection: "Collection",
    save_to_collection: "Save to collection",
    everyone_on_the_internet: 'Everyone on the internet',
    only_members: 'Only registered members',
    just_you: 'Just you',
    preview_images: "Preview Image",
    selected_preview_images: "Selected Preview Images",
    create_collection: 'New collection',
    no_collection_found: "No collections found…",
    logo: "Logo",
    app_icon: "App Icon",
    app_icon_must_be_square: "The aspect ratio of the app icon must be square.",
    logo_should_be_svg: "The logo should be a vector graphic (SVG file format).",
    app_icon_should_be_svg: "The app icon should be a vector graphic (SVG file format).",
    error: "Error",
    sorry_something_went_wrong: "Sorry, something went wrong.",
    page_not_found_title: "Page not found.",
    page_not_found_decription: "Oops! We couldn't find what you're looking for. Please give it another go later.",
    start_over: "Go back to the homepage",
    show_in_mobile_menu: "Show in mobile menu",
    explore: "Explore",
    website: "Website",
    block_user: "Block user",
    select_a_block_to_edit: "Select a block to edit",
    my_profile: "My profile",
    enter_your_full_name: "Enter your full name",
    send_us_a_message_for_account_deletion: `<a class="underline" href="/messages">Send us a message</a>, if you wish to change your email address or delete your account.`,
    empty_message_prompt: "Hey {{user_name}}! Glad you're here. \nType your message to begin.",
    response_input_placeholder: "Reply here…",
    search_contacts: "Search contacts",
    no_conversations: "No conversations found",
    yesterday: "Yesterday",
    new_message_from: "New message from {{sender}} on {{domain}}",
    new_message_from_member:
      `<p>Hello {{receiver}}!</p>
      <p>{{sender}} just sent a new message on {{domain}}.</p>
      <div style="margin:2em 0; border-left: 1px solid currentColor; padding-left: 20px;">{{message_html}}</div>
      <p><a href="{{origin}}/messages?conversation_id={{conversation_id}}" class="email-cta">Reply in Messenger</a></p>
      <p>To manage your notification settings, <a href="{{notification_settings_url}}">click here</a>.</p>`,
    new_message_from_admin:
      `<p>Hello {{receiver}}!</p>
      <p>{{sender}} just sent a new message on {{domain}}.</p>
      <p><a href="{{origin}}/messages" class="email-cta">Reply in Messenger</a></p>
      <div style="margin:2em 0; border-left: 1px solid currentColor; padding-left: 20px;">{{message_html}}</div>
      <p><a href="{{origin}}/messages" class="email-cta">Reply in Messenger</a></p>`,
    you_are_now_a_member_subject: "You are now a member of {{domain}}",
    you_are_now_a_member_message:
      `<p>Hello {{receiver}}!</p>
      <p>You are now a member of {{domain}}. That means you can for example discover exclusive content that hasn't been shared with the public.</p>
      <p>See you,<br/>{{sender}}</p>`,
    message_us: "Message us",
    messages: "Messages",
    show_all: "Show all",
    reset_filters: "Reset filters",
    tag_actions: "Tag actions",
    delete_conversation: "Delete conversation",
    select_entry: "Select entry",
    select_entries: "Select {{count}} entries",
    entry: "Entry",
    font_size_min: "Minimum font size",
    font_size_max: "Maximum font size",
    font_slant: "Font Slant",
    caption: "Caption",
    fill: "Fill",
    stroke: "Stroke",
    preamble: "Preamble",
    placeholder_preamble: "Preamble",
    placeholder_title: "Heading",
    placeholder_description: "Description",
    placeholder_primary_link: "Link",
    placeholder_secondary_link: "Second link",
    home_page: "Homepage",
    select_page: "Select page",
    change_page: "Change page",
    support_email: "Support Email",
    support_email_description: "The support email is displayed in places where your users face an issue and need to contact you",
    waiting_for_user_messages: "All clear here! There are no messages to see yet. Relax and wait until a user sends you their first message. Until then, feel free to focus on other tasks!",
    website_settings: "Website Settings",
    account: "Account",
    background: "Background",
    foreground: "Foreground",
    set_as_default: "Set as default",
    show_footer: "Show Footer",
    blocked_user_limitations: "Blocked users can no longer login or sign up to your website. However they can still see public content.",
    confirm_make_admin: "Are you sure you want to grant \"{{name}}\" admin privileges?",
    cannot_delete_own_account: "You cannot delete your own account.",
    confirm_delete_user: "Are you sure you want to delete \"{{name}}\" and all their data? Did you manually secure data that you want to keep for legal purposes (e.g. a message with an order confirmation)?",
    all_entries: "Search",
    no_access_to_all_entries: "You don't have access to all entries.",
    access_to_search: "Search Access",
    access_level: "Access for \"{{role}}\" and below",
    grant_access_level_to: "Grant access level to",
    menu_design: "Menu Design",
    filled_title: "Filled",
    encased_title: "Encased",
    outlined_title: "Outlined",
    underlined_title: "Underlined",
    frosted_glass_title: "Frosted Glass",
    beveled_title: "Beveled",
    gradient_title: "Gradient",
    ghostly_title: "Ghostly",
    elevated_title: "Elevated",
    select_a_design: "Select a design",
    inline: "Inline",
    control_design_hint: "Set the design for buttons and links.",
    control_design_title: "Buttons and Links",
    weblink: "Weblink",
    on_this_page: "On this page",
    separator: "Separator",
    spacer: "Spacer",
    spacing: "Spacing",
    search_layouts: "Search layouts",
    properties: "Properties",
    link_to_full_entries: "Link entries",
    updated_at: "Updated on",
    exit: "Exit",
    confirm_delete_selected_entries: "Are you sure you want to delete these {{count}} entries? This cannot be undone.",
    selected_entries_count: "{{count}} {{type}} selected",
    clear_filters: "Clear filters",
    page_settings: "Page Settings",
    no_collections_create_your_first: "No collections yet. Create your first one.",
    enter_collection_title: "Enter collection title",
    new_collection: "New collection",
    my_collections: "My collections",
    signup_or_login_text_label: "Signup or login text",
    signup_or_login_text_description: "This text is displayed on the login page. We suggest to include a link to your privacy policy and terms and conditions.",
    block_spacing_factor: "Block Spacing Factor",
    page_inline_spacing: "Page Inline Spacing",
    select_max_size: "Select Max Size",
    grid_gutter: "Grid Gutter",
    select_min_size: "Select Min Size",
    animation_intensity: "Animation Intensity",
    animation_intensity_description: "The intensity of animations on the website. 0 means no animations, 1 means full animations.",
    select_available_layouts_for_viewers: "Select available layouts for viewers",
    three_column_grid: "3 Column Grid",
    four_column_grid: "4 Column Grid",
    page_design: "Page Design",
    collection_layouts: "Collection Layouts",
    publish: "Publish",
    docked_s: "Docked. Small",
    docked_m: "Docked. Medium",
    docked_l: "Docked. Large",
    floating_s: "Floating. Small",
    floating_m: "Floating. Medium",
    floating_l: "Floating. Large",
    send: "Send",
    next: "Next",
    previous: "Previous",
    find_entries: "Find entries",
    elevation: "Elevation",
    mobile_alignment: "Alignment (mobile)",
    text_style: "Text Style",
    user_profile: "User Profile",
    access_to_user_profiles: "Access to user profiles",
    access_to_user_profiles_description: "Choose the minimum access level for user profiles. This setting applies to all user profiles on the website. It allows, for example, to view other users' collections.",
    access_to_search_description: "Choose the minimum access level for search. This setting applies to all users on the website. If the access level \"Public\" is selected, everyone can search for entries.",
    no_collections_hint: "No collections yet. Browse the site and discover content you like. When you find something you like, you can add it to your collection by clicking the bookmark button in the top right menu.",
    add_entries_to_collection: "Add entries to collection",
    sign_in_and_send_message: "Sign in and send message",
    messages_title: "Messenger title",
    messages_intro: "Messenger intro",
    event_reminder_emails_enabled: "Event reminder emails",
    event_reminder_emails_enabled_description: "When enabled, automatic reminder emails are sent for upcoming events.",
    send_us_a_message: "Send us a message",
    use_our_messenger_to_contact_us: "Use our messenger to contact us.",
    button: "Button",
    read_more: "Read more",
    button_label: "Button label",
    images: "Images",
    footer_color: "Footer Color",
    create: "Create",
    add_nav_item: "Add navigation item",
    mobile_menu_breakpoint: "Mobile menu breakpoint",
    image_zoom: "Image zoom",
    image_zoom_setting_description: "Allow users to zoom in on images in a fullscreen view.",
    no_collection_entries_hint: "Your collection is empty. Browse the site and add content you like using the bookmark button in the top right menu.",
    empty_collection: "Empty Collection",
    new_user_registered: "New user {{email}} just signed up at {{domain}}",
    new_user_registered_message:
      `<p>Hello {{receiver}}!</p>
      <p>{{email}} just registered at {{domain}}.</p>
      <table style="width: 100%; max-width: 600px; margin: 20px 0; border-collapse: collapse; font-family: inherit;">
        <tbody>
          <tr style="background-color: rgba(0,0,0,0.02);">
            <td style="padding: 12px; border: 1px solid rgba(0,0,0,0.1); font-weight: 600;">Email</td>
            <td style="padding: 12px; border: 1px solid rgba(0,0,0,0.1);">{{email}}</td>
          </tr>
          <tr>
            <td style="padding: 12px; border: 1px solid rgba(0,0,0,0.1); font-weight: 600;">Name</td>
            <td style="padding: 12px; border: 1px solid rgba(0,0,0,0.1);">{{name}}</td>
          </tr>
          <tr style="background-color: rgba(0,0,0,0.02);">
            <td style="padding: 12px; border: 1px solid rgba(0,0,0,0.1); font-weight: 600;">Role</td>
            <td style="padding: 12px; border: 1px solid rgba(0,0,0,0.1);">{{role}}</td>
          </tr>
          <tr>
            <td style="padding: 12px; border: 1px solid rgba(0,0,0,0.1); font-weight: 600;">Registered</td>
            <td style="padding: 12px; border: 1px solid rgba(0,0,0,0.1);">{{created_at}}</td>
          </tr>{{custom_fields_rows}}
        </tbody>
      </table>
      <p>You can verify their data <a href="{{origin}}/users">here</a>.</p>
      <p>You may want to change the role of the user (admin, member, contact).</p>
      <p>If the new user doesn't seem genuine (e.g. a spambot) you can also block them and prevent this email address from signing up again.</p>
      <p>To manage your notification settings, <a href="{{notification_settings_url}}">click here</a>.</p>`,
    enquire_about_collection: "Enquire about collection",
    collection_message_enquire_subject: "Enquiry for:",
    to_view_full_collection_become_member: "To view the full collection, become a member.",
    default_member_created_collection_entry_visibility: "Default visibility for member-created collections",
    default_member_created_collection_entry_visibility_description: "This setting applies to all collections created by members. It determines the visibility of collections when they are created. If set to “private” only members can see their collection, not even admins.",
    set_default_visibility: "Set default visibility",
    public_description: "Visible to everyone on the internet",
    member_description: "Visible to registered members",
    private_description: "Visible only to you",
    account_settings: "User account",
    switch_account: "Switch account",
    notification_preferences: "Notifications",
    receive_signup_notifications: "Receive signup notifications",
    receive_message_notifications: "Receive message notifications",
    team_access: "Team Access", 
    team_access_intro: "Let trusted team members act on your behalf. \nTeam members can:",
    team_permissions_posts: "View & edit your public and private posts.",
    team_permissions_bookings: "Make bookings using your account.",
    team_permissions_messages: "Access your messages.",
    team_access_revoke_anytime: "You can remove team access at any time.",
    team_access_limitations: "Team members cannot view or change your account settings.",
    team_member_email: "Team Member’s Email",
    enter_team_member_email: "Email address of your team member",
    add_team_member: "Add Team Member",
    invalid_email_provided: "Invalid email provided.",
    user_not_found: "User not found.",
    cannot_add_self_as_team_member: "You cannot add yourself as a team member.",
    user_already_team_member: "This user is already a team member.",
    change: "Change",
    allow_enquiry: "Allow enquiry",
    optional_link: "Optional link",
    show_more: "Show more",
    posters: "Posters",
    url: "URL",
    your_account: "Your account",
    change_image: "Change image",
    profile_picture: "Portrait",
    delete_account: "Delete account",
    webhooks: "Webhooks",
    webhook_url: "Webhook URL",
    webhook_url_placeholder: "https://hooks.zapier.com/hooks/catch/... or /api/webhooks/example-service",
    webhook_url_description: "The URL where webhook notifications will be sent. Works with Zapier, Make.com, n8n, or your own server.",
    webhook_enabled: "Enable webhooks",
    webhook_events: "Events",
    webhook_events_description: "Select which events should trigger a webhook.",
    webhook_event_user_signup: "User signup",
    webhook_event_user_signin: "User sign in",
    webhook_event_user_update: "User update",
    webhook_event_registration_new: "New event registration",
    webhook_event_registration_update: "Event registration updated",
    webhook_event_registration_cancel: "Event registration cancelled",
    webhook_preview: "Webhook preview",
    webhook_preview_description: "See an example of the data that will be sent when this event is triggered.",
    webhook_secret_info: "Webhook signature",
    webhook_secret_description: "All webhooks are signed with an HMAC SHA-256 signature header (X-Webhook-Signature). Use the WEBHOOK_SECRET from your .env file to verify the signature.",
    webhook_security_note: "Note: The webhook secret is stored server-side in your environment variables (env-file).",
    webhook_secret_not_configured: "Webhooks cannot be enabled because WEBHOOK_SECRET is not set in your environment variables (env-file). Please add WEBHOOK_SECRET to your environment variables (env-file).",
    style: "Style",
    color: "Color",
    new_poster: "New poster",
    pin: "Pin",
    unpin: "Unpin",
    pinned: "Pinned",
    registrations: "Registrations",
    view_registrations: "View Registrations",
    my_registrations: "My Registrations",
    my_registration: "My Registration",
    register_for_event: "Register for Event",
    existing_reservations: "Existing Reservations",
    new_registrations: "New Registrations",
    guest_numbered: "Guest {{number}}",
    delete_registration: "Delete Registration",
    manage_registrations: "Manage Registrations",
    update_registrations: "Update Registrations", 
    register_now: "Register Now",
    confirm_registration: "Confirm Registration",
    register: "Register",
    guest: "Guest",
    full_name: "Full Name",
    max_attendees: "Maximum Attendees",
    max_guests_per_registration: "Maximum Guests per Registration",
    for_example_location: "Subtitle (e.g. Location)",
    event_registrations_update_error: "Error updating registrations",
    event_not_found: "Event not found.",
    discard_changes_confirmation: 'You have unsaved changes. Are you sure you want to discard them?',
    registration_not_available: "Registration not available",
    event_has_concluded: "Event has concluded",
    event_is_booked_out: "Event is booked out",
    event_reminder_subject: "Reminder: {{title}} tomorrow", 
    event_reminder_intro: "We’d like to remind you about the event you registered for tomorrow:",
    event_reminder_footer: "We look forward to seeing you at the event!", 
    number_of_guests: "Number of Guests",
    add_guest: "Add Guest",
    registrations_updated: "Registrations updated",
    registration_toast_created_singular: "Registration submitted.",
    registration_toast_created_plural: "Registrations submitted.",
    registration_toast_updated_singular: "Registration updated.",
    registration_toast_updated_plural: "Registrations updated.",
    registration_toast_cancelled_singular: "Registration cancelled.",
    registration_toast_cancelled_plural: "Registrations cancelled.",
    clear: "Clear",
    hello_user: "Hello {{name}}!",
    email_sign_off: "Best wishes",
    event_registration_confirmation_subject: "Confirmation of registration for {{title}}",
    event_registration_confirmation_lead: "Your registration is confirmed.",
    event_registration_received_lead: "We have received your registration.",
    event_registration_waitlist_lead: "You are on the waitlist.",
    event_registration_waitlist_detail: "If a spot opens up, you move up automatically and get an e-mail.",
    event_registration_update_subject: "Update to registration for {{title}}",
    event_registration_update_lead: "Your registration has been changed.",
    event_registration_cancellation_subject: "Cancellation of registration for {{title}}",
    event_registration_cancellation_lead: "Your registration has been cancelled.",
    event_registration_promotion_subject: "Your spot for {{title}} is confirmed",
    event_registration_promotion_lead: "You got a spot.",
    event_registration_promotion_detail: "A spot has opened up and you have moved up from the waitlist.",
    view_registration: "View registration",
    guests: "Guests",
    go_to_event: "Go to event",
    price: "Price",
    event_price_currency: "Currency",
    stripe_not_configured_warning: "Stripe is not configured for this site (STRIPE_SECRET_KEY missing). Members cannot register until payments are set up.",
    price_below_minimum: "The minimum amount is {{min}}. A lower price can't be charged.",
    currency_code_invalid: "Please enter a three-letter currency code (e.g. EUR).",
    amount_invalid: "Please enter a valid amount.",
    complete_payment: "Complete payment now",
    cancel_payment: "Cancel payment",
    event_payment_success_notice: "Thank you! Your payment was received and your registration is confirmed. You will receive a confirmation email.",
    event_payment_processing_notice: "Thank you! Your payment is being processed. Your spots stay reserved until it clears – you will get an email once it does.",
    event_payment_pending_notice: "Thank you! Your payment is still being confirmed. You will receive a confirmation email as soon as it arrives.",
    event_payment_cancelled_notice: "The payment was cancelled. Your spots stay reserved for about 30 minutes – you can complete the payment from your registration.",
    event_payment_not_configured: "Payments are not yet set up for this event. Please contact the organizers.",
    event_payment_session_error: "The payment could not be started. Please try again later.",
    event_registration_paid_cancel_locked: "Paid spots can't be cancelled by you. Please contact the organizers for a refund.",
    payment_processing_note: "Your payment is being processed – your spot is reserved.",
    event_registration_payment_processing: "The payment for this registration is still being processed. Please wait until it has settled.",
    event_registration_payment_processing_admin: "This payment is still open at Stripe (e.g. a bank debit that is still being collected). It can't be cancelled, here or at Stripe, until Stripe reports the outcome, usually within a few business days. If the payment fails, the seats are released automatically.",
    event_payment_refunded_notice: "This payment was refunded. The spots are not reserved.",
    notes_too_long: "The note is too long.",
    paid_registration_cancel_note: "To cancel a paid spot, please contact the organizers.",
    // Event ticket (inline-editable header card)
    price_empty_hint: "free",
    free_of_charge: "Free",
    price_per_person: "{{price}} per person",
    seats: "Seats",
    unlimited: "unlimited",
    seats_remaining_of: "{{remaining}} of {{total}} seats left",
    people: "People",
    people_count: "{{count}} people",
    person_count_singular: "1 person",
    you: "You",
    amount_paid_inline: "{{amount}} paid",
    sold_out: "Sold out",
    all_seats_taken: "All {{total}} seats are taken.",
    waitlist_full: "Waitlist full.",
    change_guests: "Change guests",
    cancel_short: "Cancel",
    registration_cancel_until_start: "You can cancel until the event starts.",
    leave_waitlist: "Leave the waitlist",
    registration_link_placeholder: "https://… or email address",
    // Member sign-up form and status card
    email_optional: "Email (optional)",
    email_short: "Email",
    name_required: "Please enter a name.",
    name_too_long: "Please enter a shorter name (255 characters max).",
    email_invalid: "Please enter a valid email address.",
    email_too_long: "Please enter a shorter email address (255 characters max).",
    submit_registration: "Register",
    submit_registration_paid: "Register and pay",
    payment_hold_note: "Your seats stay reserved for {{minutes}} minutes – that is how long you have to pay.",
    complete_registration_title: "Complete your registration",
    complete_registration_note: "You are signed in as {{name}} – check your details and confirm your registration.",
    registered_title: "Registered",
    registered_guests_count: "{{count}} people registered",
    registered_guests_count_singular: "1 person registered",
    payment_open_title: "Payment open",
    payment_open_until: "Your seats are reserved until {{time}}.",
    payment_confirming_title: "Confirming payment…",
    payment_confirming_note: "This only takes a moment – your seats are reserved.",
    waitlisted_title: "On the waitlist",
    waitlist_position_note: "You move up automatically as soon as a seat frees up.",
    refunded_note: "Your payment was refunded, which cancels the registration.",
    cancel_my_registration: "Cancel registration",
    confirm_cancel_my_registration: "Really cancel?",
    add_guests: "Add guests",
    // Admin guest list
    guest_list: "Guest list",
    guest_list_summary_seats: "{{taken}} of {{total}} seats",
    guest_list_summary_paid: "{{count}} paid",
    guest_list_summary_unpaid: "{{count}} open",
    guest_list_summary_pending: "{{count}} paying",
    guest_list_summary_waitlist: "{{count}} on the waitlist",
    guest_list_empty: "No registrations yet.",
    show: "Show",
    hide: "Hide",
    email_all: "Email everyone",
    csv: "CSV",
    payment: "Payment",
    payment_method: "Payment method",
    amount: "Amount",
    paid_at: "Received on",
    notes: "Note",
    payment_state_paid: "Paid",
    payment_state_unpaid: "Open",
    payment_state_comp: "Comp",
    payment_state_refunded: "Refunded",
    payment_state_pending: "Paying",
    payment_state_processing: "Processing",
    payment_state_free: "—",
    payment_method_stripe: "Stripe",
    payment_method_bank_transfer: "Bank transfer",
    payment_method_cash: "Cash",
    payment_method_invoice: "Invoice",
    payment_method_comp: "Comp",
    send_receipt: "Send e-mail",
    mark_as_paid: "Mark as paid",
    mark_as_comp: "Mark as comp",
    mark_as_unpaid: "Clear payment",
    payment_recorded: "Payment recorded.",
    payment_cleared: "Payment cleared.",
    event_registration_payment_stripe_locked: "Stripe payments can only be refunded through Stripe.",
    confirm_remove_guest: "Remove {{name}} from the guest list?",
    saved: "Saved",
    event_registration_email_recipients_unpaid: "Unpaid",
    event_registration_payment_failed_subject: "Payment failed: {{title}}",
    event_registration_payment_failed_lead: "Your payment failed.",
    event_registration_payment_failed_detail: "The payment could not be collected, so your registration has been cancelled. While seats remain, you can register again.",
    event_registration_payment_received_subject: "Payment received: {{title}}",
    event_registration_payment_received_lead: "Thank you for your payment, your seat is confirmed.",
    series_cancellation_subject: "{{count}} events cancelled",
    series_cancellation_message: "The following {{count}} events you were registered for have been cancelled:",
    event_registration_admin_notification_subject: "[{{type}}] {{title}}",
    event_registration_admin_notification_greeting: "Hello,",
    event_registration_admin_notification_message: "There has been a {{type}} for «{{title}}».",
    event_registration_admin_notification_type_new: "New registration",
    event_registration_admin_notification_type_update: "Registration update",
    event_registration_admin_notification_type_cancel: "Cancellation",
    event_registration_admin_notification_type_promotion: "Waitlist promotion",
    event_registration_admin_notification_footer: "This email was sent automatically by {{site_name}}.",
    registration_details: "Registration details",
    registered_by: "Registered by",
    on_behalf_of: "On behalf of",
    event_body_notice: "Add blocks of text, images, videos, and other content to your event page.",
    registration_settings: "Registration settings",
    event_tab_schedule: "Date",
    event_tab_registration: "Registration",
    event_status_question: "Is the event going ahead?",
    event_status_option_scheduled: "Yes, as planned",
    registration_mode_question: "How do guests register?",
    registration_mode_option_here: "On this page",
    registration_mode_option_link: "External link",
    registration_mode_option_none: "None",
    price_per_person_label: "Price per person",
    seat_count_label: "Number of seats",
    show_remaining_seats_public: "Show remaining seats publicly",
    max_guests_per_registration_label: "Max. people per registration",
    waitlist_seats_label: "Waitlist seats",
    registration_link_label: "Registration link",
    registration_button_text_label: "Registration button text",
    registration_notification_label: "Email new registrations to",
    confirm_changes: "Confirm changes",
    cancel_all_registrations: "Cancel all",
    cancel_registration: "Cancel registration",
    count_of_registrations_marked_for_deletion: "{{count}}× registrations are marked for cancellation",
    one_registration_marked_for_deletion: "1× registration is marked for cancellation",
    open_tasks: "Open tasks",
    what_do_you_want_to_share: "What do you want to share?",
    set_heading_size: "Heading",
    no_heading: "No heading",
    heading_level: "Heading level {{level}}",
    heading_paragraph_style: "Title in paragraph style",
    terms_and_conditions: "Terms and Conditions",
    privacy_policy: "Privacy Policy",
    data_processing: "Data processing",
    email_signature: "E‑Mail Signature",
    my_email_signature: "My email signature",
    signature_template: "Template",
    signature_template_title: "Signature template",
    signature_preview_phone: "Phone",
    signature_preview_dark: "Dark mode",
    signature_preview_brand_font: "Web font",
    signature_field_name: "Name",
    signature_field_role: "Role",
    signature_field_email: "Email",
    signature_field_phone: "Phone",
    signature_field_mobile: "Mobile",
    signature_field_address: "Address",
    signature_field_website: "Website",
    signature_field_links: "Links",
    signature_field_footnote: "Footnote",
    signature_placeholder_name: "First and last name",
    signature_placeholder_role: "Role",
    signature_placeholder_email: "name@company.com",
    signature_placeholder_phone: "Phone",
    signature_placeholder_mobile: "Mobile",
    signature_placeholder_address: "Street, postcode and city",
    signature_placeholder_footnote: "Legal information",
    signature_buttons: "Buttons",
    signature_add_link: "Add link",
    signature_add_button: "Add button",
    signature_link_label: "Label",
    signature_copy_description_outlook: "Copies formatted text for the Outlook signature editor.",
    signature_copy_description_ios: "Copies as formatted text for pasting into the iOS Mail settings.",
    signature_copy_description_apple_mail: "Copies as a full HTML document.",
    signature_copy_description_gmail: "Copies as formatted text for pasting directly into Gmail.",
    signature_sample_phone: "+1 000 000 0000",
    signature_sample_role: "Role",
    signature_install_intro: "Choose your email client",
    signature_site_font: "website",
    signature_details_font: "Text",
    signature_fonts: "Fonts",
    signature_color: "Colour",
    signature_fields_hint: "Type the address and footnote straight into the signature. They apply to everyone.",
    signature_lines_hint: "One line per title, role or affiliation.",
    signature_links_hint: "Social profiles or websites.",
    signature_buttons_hint: "For example your meeting booking page.",
    signature_hint: "Empty fields don't appear in the signature.",
    signature_redo: "Redo",
    signature_edit_template: "Edit template",
    signature_button_example: "Book a meeting",
    signature_layout_logo_top: "Logo top",
    signature_layout_logo_top_description: "Logo on top, the text indented below it",
    signature_layout_logo_top_flush: "Logo top, aligned",
    signature_layout_logo_top_flush_description: "Logo on top, the text below it in one column",
    signature_layout_logo_left: "Logo left",
    signature_layout_logo_left_description: "Logo in its own column, above the details on phones",
    signature_layout_logo_middle: "Logo middle",
    signature_layout_logo_middle_description: "Logo between name and contact details",
    signature_layout_logo_below_labels: "Logo below with labels",
    signature_layout_logo_below_labels_description: "Labelled rows, logo, rule and footnote",
    signature_layout_logo_below: "Logo below",
    signature_layout_logo_below_description: "Plain lines, the logo last",
    signature_layout_compact: "Compact",
    signature_layout_compact_description: "Two lines and a small logo, no buttons",
    signature_logo_site: "Website logo",
    signature_logo_image: "Other image",
    signature_logo_width: "Width in px",
    signature_no_logo: "No logo",
    signature_undo: "Undo",
    signature_install: "Install",
    signature_template_saved: "Template saved",
    signature_save_failed: "Couldn't save. Try again.",
    signature_install_title: "Install my email signature",
    signature_client_gmail: "Gmail",
    signature_client_apple_mail: "macOS Mail",
    signature_client_ios: "iOS Mail",
    signature_client_outlook_web: "Outlook Web",
    signature_client_outlook_windows: "Outlook Windows",
    signature_client_outlook_mac: "Outlook Mac",
    signature_install_copy_title: "Copy your signature",
    signature_copy: "Copy signature",
    signature_copied: "Signature copied",
    signature_copy_failed: "Couldn't copy. Allow the browser to use the clipboard and try again.",
    signature_install_add_gmail: "Add to Gmail",
    signature_install_add_apple_mail: "Add to Apple Mail",
    signature_install_add_ios: "Add to iOS Mail",
    signature_install_add_outlook_web: "Add to Outlook Web",
    signature_install_add_outlook_windows: "Add to Outlook Windows",
    signature_install_add_outlook_mac: "Add to Outlook Mac",
    signature_steps_gmail: "Go to [mail.google.com](https://mail.google.com) and log in.\nClick the Settings gear icon → “See all settings”.\nScroll down to the Signature section.\nClick “Create new”, name it, and click “Create”.\nPaste your copied signature into the text editor.\nKeep the logo at its pasted size ({{width}} px wide).\nSet as default for new emails and replies (optional).\nClick “Save Changes” at the bottom.",
    signature_note_gmail: "Note: Gmail doesn’t support custom web fonts, so fonts may appear different.\nDark mode: Messages sent from Gmail may keep a white background in Apple Mail, even in dark mode, because Gmail can remove the signature’s dark-mode styling.",
    signature_steps_apple_mail: "Open Apple Mail → “Mail” menu → “Settings”.\nClick the “Signatures” tab → select “All Signatures”.\nClick “+” to add a new signature.\nAdd the placeholder text `XXXXXXX` in the signature panel.\nDrag the signature to your email account and set it as default under “Choose Signature”.\nClose Settings and quit Apple Mail completely (⌘Q).\nOpen Finder, press ⇧⌘G and type `~/Library/Mail`.\nOpen the folder with the highest “V” number → “MailData” → “Signatures”.\nFind the newest `.mailsignature` file (sort by “Date Modified”).\nRight-click → “Open With > TextEdit”.\nUse plain-text mode in TextEdit. Keep the mail headers above the first blank line and replace the entire HTML below them with your copied signature.\nSave and close TextEdit.\nRight-click the file → “Get Info” → check “Locked”.\nOpen Apple Mail and verify your signature looks correct.",
    signature_note_apple_mail: "Important: Locking the file prevents Apple Mail from overriding your signature.",
    signature_steps_ios: "Open “Settings” → “Apps” → “Mail” → “Signature”.\nChoose “All Accounts” or select a specific account.\nPaste your copied signature into the text field.",
    signature_note_ios: "Note: Web fonts are not supported on iOS, so fonts may appear different.",
    signature_steps_outlook_web: "Go to [outlook.office.com](https://outlook.office.com) (work account) or [outlook.live.com](https://outlook.live.com) (personal account) and log in.\nClick the Settings gear icon → “View all Outlook settings”.\nSelect “Mail” → “Compose and reply”.\nUnder Email signature, click “New Signature”.\nPaste your signature into the text box.",
    signature_steps_outlook_windows: "Open Outlook and click “File” in the menu bar.\nSelect “Options” → “Mail” tab.\nClick “Signatures” → “New”.\nName your signature and paste it into the text box.\nClick “OK” to save.",
    signature_steps_outlook_mac: "In the menu bar, go to “Outlook” → “Settings” → “Signatures”.\nClick the “+” icon.\nName your signature (click the pencil, or double-click the name).\nClear the text box: press ⌘A, then Delete.\nPaste into the text box (⌘V).\nIf it looks different and Outlook asks about formatting, choose “Keep Source Formatting”.\nOptionally, choose it under “Set default signatures” below.",
    signature_install_test_note: "Then send yourself a test email and check the received signature. The preview here doesn't reproduce every mail program.",
    signature_text: "Signature Text",
    enter_signature_text: "Enter signature text",
    signature_image: "Signature Image",
    event_status: "Event status",
    event_status_scheduled: "Scheduled",
    event_status_cancelled: "Cancelled",
    event_status_postponed: "Postponed",
    event_status_tooltip: "Cancelled: new registrations are closed and reminder emails stop. Existing registrations can still be cancelled. Postponed: same behavior as cancelled, but visitors see “postponed until further notice”.",
    registration_mode_internal: "Active",
    registration_mode_external: "Individual",
    registration_mode_disabled: "Inactive",
    registration: "Registration",
    remaining_spots: "Only {{count}} spots remaining!",
    remaining_spot_singular: "Only 1 spot remaining!",
    email_signature_image_requirements: "The signature image should be an optimised image with less than 600px width. File formats like SVG, WebP, AVIF are only partly supported in email applications.",
    download_registrations: "Download registrations ({{count}}×)",
    export_csv: "Export",
    event_date: "Event Date",
    registrations_exceed_max_attendees: "Sorry. The maximum number of attendees is already reached",
    registrations_exceed_max_guests: "You can't register more guests than are allowed per booking.",
    waitlist: "Waitlist",
    get_off_the_waitlist: "The event is fully booked. These registrations will move off the waitlist if spots become available",
    waitlist_spots: "{{count}} spots available on the waitlist",
    waitlist_spot_singular: "1 spot available on the waitlist",
    waitlist_capacity: "Waitlist capacity",
    event_is_fully_booked: "Fully booked",
    event_is_cancelled: "Event cancelled",
    event_is_postponed: "Event postponed",
    event_cancelled_notice: "This event is currently cancelled. New registrations are closed. Existing registrations can still be cancelled.",
    event_postponed_notice: "This event is postponed until further notice. New registrations are closed. Existing registrations can still be cancelled.",
    event_inactive_registration_changes_restricted: "This event is cancelled or postponed. You can only cancel existing registrations.",
    // Series/recurring events
    series_event: "Series event",
    series_base_event: "Base event",
    go_to_base_event: "Go to base event",
    recurrence: "Recurrence",
    does_not_repeat: "Does not repeat",
    repeats_daily: "Daily",
    repeats_weekly: "Weekly",
    repeats_monthly: "Monthly",
    series_end_date: "Series end date",
    series_will_create_n_events: "This will create {{count}} events",
    series_creating_events: "Creating {{count}} events…",
    series_created: "Series created: {{count}} events",
    edit_this_event_only: "You are editing this event only. Changes will not affect other events in this series.",
    edit_all_future_events: "Edit all future events",
    edit_all_future_events_confirm: "These changes will be applied to all future events in this series.",
    delete_future_events: "Delete future events",
    delete_entire_series: "Delete entire series",
    delete_this_and_future_events: "Delete this and future events",
    delete_all_events: "Delete all events",
    notify_registrants_of_cancellation: "Notify registered participants by email",
    delete_empty_only: "Delete only events without registrations",
    series_impact_summary: "{{total}} future events, {{with_reg}} have registrations ({{reg_count}} total registrants)",
    series_impact_no_registrations: "{{total}} future events, no registrations",
    part_of_series: "Part of a series ({{frequency}})",
    series_delete_confirm_title: "Delete series events",
    series_dates_preview_title: "Date overview",
    base_event: "Base event",
    series_bulk_select_hint: "Select the fields whose current value you want to apply to all future events.",
    apply_to_all_future: "Apply to all future events",
    save_this_event_only: "This event only",
    series_save_scope_title: "Apply changes to series?",
    series_save_scope_description: "This event has been saved. Select which fields to apply to all future events.",
    series_confirm_override_title: "Confirm changes",
    series_confirm_override_description: "{{fields}} fields will be overridden on {{count}} future events.",
    confirm_override: "Update {{count}} events",
    series_field_content: "Content",
    series_field_subtitle: "Subtitle",
    series_field_link: "Link",
    series_field_time: "Time",
    series_field_pricing: "Price",
    series_too_many_occurrences: "Too many occurrences ({{count}}). Maximum {{max}} allowed.",
    series_correct_end_date: "Adjust end date",
    series_promote_notice: "Saving will convert this event into a series and create {{count}} additional events. The recurrence cannot be changed afterwards.",
    series_ends: "Series ends",
    series_end_by_date: "On date",
    series_end_after_count: "After count",
    series_repeat_count: "Number of events",
    series_occurrences_unit: "events",
    series_interval: "Interval",
    series_interval_every: "Every",
    series_interval_unit_daily_singular: "day",
    series_interval_unit_daily_plural: "days",
    series_interval_unit_weekly_singular: "week",
    series_interval_unit_weekly_plural: "weeks",
    series_interval_unit_monthly_singular: "month",
    series_interval_unit_monthly_plural: "months",
    detach_from_series: "Detach from series",
    detach_from_series_title: "Detach from series?",
    detach_from_series_description: "This event will be detached from the series and become a fully independent standalone event. Future series-wide changes will no longer affect it.",
    detach_from_series_confirm: "Detach",
    detach_from_series_success: "Event detached from series",
    select_all: "Select all",
    deselect_all: "Deselect all",
    confirm_cancel_registrations: "Are you sure you want to cancel these registrations?",
    waitlist_capacity_warning: "Warning: {{current}} people are currently on the waitlist. Reducing capacity to {{new}} will not remove existing waitlist registrations, but will prevent new ones.",
    add_to_waitlist: "Add to waitlist",
    greeting_user: "Hello {{name}}!",
    registration_email_sent: "We have sent an email to {{email}} for your registrations.",
    registration_email_notice: "Email sent to {{email}}.",
    max_attendees_tooltip: "Sets the maximum number of attendees. Only up to this number can join the event (excluding waitlist).",
    max_guests_per_registration_tooltip: "Specifies the maximum number of guests allowed per registration. This allows for group registrations or registering with a companion. For example, a value of 2 means each person can register themselves and one companion.",
    waitlist_capacity_tooltip: "Defines the number of additional spots on the waitlist. This value accounts for potential cancellations. It should be chosen carefully to keep the waitlist manageable and avoid raising false hopes. Example: With 30 max attendees and 10 waitlist spots, a total of 40 registrations are possible.",
    signup_data_processing_consent_required_description: "Activate this option if your visitors must actively consent to data processing.",
    consent_required: "Consent required",
    registered: "Registered",
    copied_to_clipboard: "{{value}} copied",
    display_capacity: "Display capacity",
    display_capacity_tooltip: "Display the capacity on the event page to the public.",
    registration_notification_email: "Notification email",
    registration_notification_email_tooltip: "Email address to notify when users register, update or cancel their registrations.",
    email_registrants: "New email to registered users",
    event_registration_email_popover_title: "Email to registered users",
    event_registration_email_recipients_group: "Recipient group",
    event_registration_email_recipients_all: "All",
    event_registration_email_recipients_registered: "Registered only",
    event_registration_email_recipients_waitlist: "Waitlist only",
    event_registration_email_recipients: "Recipient emails",
    event_registration_email_recipients_hint: "Recipients with an email address: {{count}}. The list can be edited.",
    event_registration_email_recipients_placeholder: "name@example.com",
    event_registration_email_subject: "Subject",
    event_registration_email_subject_placeholder: "Enter subject",
    event_registration_email_body: "Message",
    event_registration_email_body_placeholder: "Message (plain text only, multiline allowed)",
    event_registration_email_preview_message: "Message (as sent)",
    event_registration_email_preview_notice: "Note: The email template and configured signature are added automatically.",
    event_registration_email_send: "Send email",
    event_registration_email_sending: "Sending email...",
    event_registration_email_sent_success: "{{count}} emails sent.",
    event_registration_email_sent_success_singular: "1 email sent.",
    event_registration_email_sent_partial: "{{sent}} sent, {{failed}} failed.",
    event_registration_email_dialog_title: "Email registrants",
    event_registration_email_review: "Review draft",
    event_registration_email_back_to_edit: "Back to edit",
    event_registration_email_send_now: "Send emails now",
    event_registration_email_progress: "Processed: {{processed}} of {{total}}",
    event_registration_email_status_pending: "Waiting to start...",
    event_registration_email_status_running: "Sending emails...",
    event_registration_email_status_sent: "All emails sent.",
    event_registration_email_status_partial: "Some emails could not be sent.",
    event_registration_email_status_failed: "Email sending failed.",
    event_registration_email_progress_details: "Sent: {{sent}} · Failed: {{failed}}",
    event_registration_email_failed_recipients: "Failed recipients",
    event_registration_email_compose_another: "Compose another email",
    event_registration_email_done: "Done",
    event_registration_email_send_failed: "Unable to send emails.",
    event_registration_message_subject_required: "Please enter a subject.",
    event_registration_message_subject_too_long: "Subject is too long (max {{limit}} characters).",
    event_registration_message_body_required: "Please enter a message.",
    event_registration_message_body_too_long: "Message is too long (max {{limit}} characters).",
    event_registration_message_no_recipients: "Please enter at least one valid recipient email.",
    event_registration_message_too_many_recipients: "Too many recipients (max {{limit}}).",
    event_registration_message_invalid_recipients: "Invalid email addresses: {{emails}}",
    event_registration_message_job_already_running: "An email send is already in progress. Please wait until it finishes.",
    event_registration_message_job_not_found: "Email send job not found.",
    event_registration_message_job_timed_out: "Email sending took too long and was stopped.",
    event_registration_email_send_error: "An error occurred while sending emails.",
    max_guests_limit_reached: "You’re registered - no more guests can be added to your registration.",
    messenger_link_prefill_title: "Pre-filled Message (optional)",
    messenger_link_prefill_subtitle: "The user gets this text in the chat window, but can freely modify it before sending.",
    messenger_link_description: "Optional pre-filled",
    messenger: "Messenger",
    insert_link: "Insert link",
    insert_email: "Insert email",
    insert_phone: "Insert phone",
    internal_notes: "Internal notes",
    report_poster_details: 'Reporting Poster:\nTitle: {{title}}\nAuthor: {{author}}\nDate: {{date}}\n\nReason for reporting: [Please add your reason here]',
    searching: "Searching...",
    no_results_found: "No results found",
    start_typing_to_search: "Start typing to search...",
    select_logo_size: "Select logo size",
    tall: "Tall",
    short: "Short",
    show_label_with_image: "Show label with image",
    change_nav_item: "Change item",
    button_design: "Button design",
    change_image_size: "Change image size",
    represented_by: "Represented by",
    delegatory: "Delegated by",
    tomorrow: "Tomorrow",
    this_week: "This week",
    events_this_month: "This month",
    archive: "Archive",
    upcoming_events: "Upcoming",
    past_events: "Past Events",
    past: "Past",
    my_event_registrations: "My Event Registrations",
    invoices: "Invoices",
    need_invoice: "I need an invoice",
    customer_portal_headline: "Manage your invoices, billing address and VAT ID",
    no_event_registrations: "You haven't registered for any events yet.",
    view_event: "View Event",
    manage_my_registration: "Manage Registration",
    registered_on: "Registered on",
    user_profile_description: "Login for non-signed in users",
    confirm_delete_color_set: "Are you sure you want to delete this color set? All elements that use this color set will be reset to the default color set.",
    select_a_color_set: "Select a color set",
    color_name: "Color name",
    cannot_delete_default: "Cannot delete the default color set",
    cannot_delete_last_color: "Cannot delete the last color set",
    drag_to_reorder_default: "Drag another color to the top to set it as default",
    add_color_set: "Add color set",
    emphasis: "Emphasis",
    color_input_hint: "Paste HEX or RGB to convert to OKLCH",
    default: "Default",
    variable_font: "Variable Font",
    static_font: "Static Font",
    italic: "Italic",
    normal: "Normal",
    minor_second: "Minor Second",
    major_second: "Major Second",
    minor_third: "Minor Third",
    major_third: "Major Third",
    perfect_fourth: "Perfect Fourth",
    augmented_fourth: "Augmented Fourth",
    perfect_fifth: "Perfect Fifth",
    golden_ratio: "Golden Ratio",
    font_sizes: "Font sizes",
    font_sizes_help: "Each style sits on a step of the scale. Sizes are calculated separately for phone and desktop; in between, the midpoint applies.",
    scale_phone: "Phone · up to 768 px",
    scale_desktop: "Desktop · from 1281 px",
    scale_phone_short: "Phone",
    scale_desktop_short: "Desktop",
    base_size: "Base size",
    scale_ratio: "Ratio",
    scale_step: "Step",
    sizes_follow_scale: "All sizes follow the scale.",
    sizes_differ_from_scale: "Some sizes differ from the scale.",
    apply_scale: "Apply scale",
    style_heading1: "Heading 1",
    style_heading2: "Heading 2",
    style_heading3: "Heading 3",
    style_body: "Body text",
    style_control: "Controls",
    style_caption: "Caption",
    style_preamble: "Preamble",
    emphasis_background: "Emphasis Background",
    emphasis_foreground: "Emphasis Foreground",
    team: "Team",
    id: "ID",
    invalid_video_format: "Invalid video format. Please use MP4 or WebM.",
    video_resolution_too_high: "Video resolution is too high (max {{dimension_limit}}px on the longest edge). Please re-encode your video to a lower resolution using a free tool like Handbrake.",
    video_file_too_large: "Video is too big (max {{size_limit_mb}}MB). Please compress your video using a free tool like Handbrake.",
    image_file_too_large: "Image is too big. Please use smaller web-optimized images ({<{size_limit_kb}}kb).",
    unsupported_image_format_on_browser: "HEIC/HEIF processing is only supported on Safari. Please convert to JPEG first.",
    unsupported_file_type: "Unsupported file type. Please upload a supported image or video file.",
    unknown_upload_error: "An unknown error occurred during file processing. Please try again.",
    upload_failed: "Upload failed. Check your connection and retry.",
    image_upload_too_large: "The image is too large (max {{size_limit_mb}} MB). Please choose a smaller image.",
    image_upload_unsupported: "This image can't be used. Please choose a different image.",
    uploading: "Uploading",
    optimizing: "Optimizing",
    optimizing_safe_to_leave: "Optimizing — safe to save or leave",
    finishing_uploads: "Finishing {{count}} upload(s)…",
    upload_in_progress_warning: "An upload is still in progress.",
    added_to_library: "Added to library",
    open_media_library: "Open media library",
    upload_media: "Upload media",
    drop_or_paste_files: "Drag files here or paste (Cmd+V)",
    each_file_becomes_entry: "Each file becomes its own entry in the media library.",
    image_credits: "Credits",
    save_failed: "Save failed",
    already_in_library: "Already in library — using the existing entry",
    pasted_anchors_removed: "In-page links removed — they pointed at sections of the original page",
    retry: "Retry",
    add_media: "Add media",
    upload_images: "Upload images",
    crop_to_fill: "Crop to fill",
    show_whole_image: "Show whole image",
    image_fit: "Image fit",
    whole_image: "Whole image",
    video: "Video",
    preview_card: "Preview card",
    show_in_search: "Show in search",
    not_in_search: "Not in search",
    all_formats: "All aspect ratios",
    asset_id: "Path",
    mime_type: "File type",
    variants: "Variants",
    variant_count: "Variants",
    not_applicable: "–",
    pending: "Pending",
    ready: "Ready",
    errors: "Errors",
    image_variant_coverage: "Image variant coverage",
    images_with_variants: "images with variants",
    missing: "missing",
    pending_jobs: "pending jobs",
    errored_jobs: "errored jobs",
    select_files: "Choose files",
    drop_or_select_files: "Drop files here or click to choose",
    visible_in_all_formats: "Visible in all {{count}} aspect ratios",
    cropped_by_some_formats: "Cropped at some aspect ratios",
    never_cropped: "Whole image — never cropped",
    crop: "Crop",
    crop_format: "Format",
    crop_free: "Free",
    crop_original: "Original",
    crop_reset: "Reset",
    cropping: "Cropping …",
    crop_failed: "Cropping failed",
    crop_area: "Crop area",
    entry_default: "Entry default",
    alt_text_missing: "Alt text missing",
    aspect_ratio_label: "Aspect ratio",
    auto: "Auto",
    entry_changed_reload_confirm: "This page was changed by someone else in the meantime. OK: reload (your changes are lost). Cancel: keep your version and overwrite on next save.",
    draft_restore_confirm: "There is an unsaved draft of this page. Restore the draft?",
    entry_save_not_allowed: "This account can't save changes here. Sign in with an admin account.",
    uploaded_images_stay_in_library: "Already uploaded images stay in your library.",
    video_duration_too_long: "Video is too long (max {{duration_limit}} seconds). Please shorten the video.",
    video_metadata_error: "Could not read video metadata. The file might be corrupted or in an unsupported format.",
    by: "By",
    cover: "Cover",
    type: "Type",
    relative_path: "Relative path",
    file: "File",
    show_all_contacts: "Show all contacts",
    messages_filter_all: "All",
    messages_filter_unread: "Unread",
    messages_filter_awaiting_reply: "Awaiting reply",
    no_matching_conversations: "No matching contacts found",
    message_sent: "Sent",
    message_delivered: "Delivered",
    message_read: "Read",
    add_tag: "Add tag",
    edit_tag: "Edit tag",
    delete_tag: "Delete tag",
    tag_name: "Tag name",
    confirm_delete_tag: "Are you sure you want to delete this tag? It will be everywhere.",
    create_new_tag: "Create new tag",
    count_selected: "{{count}}× selected",
    tags: "Tags",
    no_one_off_events: "No one-off events are announced at the moment.",
    see_regular_dates: "See regular dates",
    regular_dates: "Regular",
    dates_count: "{{count}} dates",
    one_date: "1 date",
    rhythm_every_other_week: "every other week",
    rhythm_monthly: "{{nth}} {{weekday}} of the month",
    ordinal_1: "1st",
    ordinal_2: "2nd",
    ordinal_3: "3rd",
    ordinal_4: "4th",
    ordinal_last: "last",
    next_date: "next {{date}}",
    no_regular_dates: "There are no regular dates at the moment.",
    no_events_this_year: "Nothing is announced for this year.",
    next_event_label: "Next event",
    category_label: "Category",
    show_category: "Show",
    running_this_day: "On this day",
    program_automatic: "Next events automatically",
    program_automatic_hint: "This block shows the next events from the calendar. New ones appear after saving.",
    allow_member_collection_images: "Members may upload pictures into their own collections",
    allow_member_collection_images_description: "For artists who keep their own page: they upload their works and add titles and details. Pages, events and settings stay with the admins.",
    upload_pictures: "Upload pictures",
    uploading_n_of_m: "Uploading … {{n}} of {{m}}",
    picture_title: "Title",
    picture_details: "Year, technique, size",
    upload_failed_named: "{{name}} could not be uploaded.",
    program: "Program",
    calendar_view: "View",
    all_categories: "All",
    running_now: "On now",
    coming_up: "Coming up",
    load_year: "Load {{year}}",
    events_count: "{{count}} events",
    one_event: "1 event",
    no_upcoming_events: "Nothing is announced at the moment.",
    running_this_month: "On this month",
    running_this_week: "On this week",
    running_this_year: "Exhibitions and multi-day events",
    new_event_on_day: "Event",
    more_events: "{{count}} more",
    no_events_this_day: "Nothing is announced for this day.",
    no_events_this_week: "Nothing is announced for this week.",
    no_events_this_month: "Nothing is announced for this month.",
    no_events_in_month_short: "—",
    to_program: "To the program",
    calendar_week_short: "Week",
    not_public: "Not public",
    event_details: "Details",
    previous_period: "Previous",
    next_period: "Next",
    insert: "Insert",
    from_library: "From the library …",
    new_entry_of_type: "Create new",
    block: "Block",
    tags_of_entry: "Tags of this entry",
    first_colored_tag_note: "The first tag with a colour gives the entry its colour, for example in the calendar.",
    search_or_create_tag: "Search or create a tag",
    manage_tags_and_colors: "Manage tags and colours",
    move_to_front: "Move to front",
    no_tags_yet: "No tags yet",
    no_color: "No colour",
    rename: "Rename",
    tags_settings_help: "A tag with a colour is a category: it colours entries in the calendar and the program and appears as a filter. The colours come from the colour sets above. Changes to tags apply immediately.",
    tag_color: "Colour",
    internal: "Internal",
    admins_only_visibility: "Visible to admins only",
    by_signing_up_you_agree_to_the_privacy_policy_and_terms_and_conditions: "By signing up you agree to the <a href='{{privacy_policy}}' target='_blank' class='underline'>Privacy Policy</a> and <a href='{{terms_and_conditions}}' target='_blank' class='underline'>Terms and Conditions</a>.",
    by_signing_up_you_agree_to_the_privacy_policy: "By signing up you agree to the <a href='{{privacy_policy}}' target='_blank' class='underline'>Privacy Policy</a>.",
    by_signing_up_you_agree_to_the_terms_and_conditions: "By signing up you agree to the <a href='{{terms_and_conditions}}' target='_blank' class='underline'>Terms and Conditions</a>.",
    field_is_required: "{{field}} is required",
    custom_field_label: "Field Label",
    custom_field_placeholder: "Placeholder Text",
    custom_field_type: "Field Type",
    custom_field_required: "Required",
    custom_field_options: "Options",
    add_option: "Add Option",
    delete_field: "Delete Field",
    confirm_delete_field_message: "Are you sure you want to delete this field? All data submitted by users in this field will be permanently deleted after saving settings.",
    custom_form_fields: "Custom Form Fields",
    signup_form_fields: "Signup Form Fields",
    configure_custom_fields_description: "Configure additional fields to collect from users during signup. The name and email fields are always required.",
    no_custom_fields_configured: "No custom fields configured. Click \"Add Field\" to create your first custom field.",
    add_field: "Add Field",
    field_id: "Field ID",
    field_type_text: "Single Line Text",
    field_type_longtext: "Multi Line Text",
    field_type_float_number: "Decimal Number",
    field_type_integer_number: "Integer Number",
    field_type_checkbox: "Checkbox",
    field_type_select: "Select List",
    field_type_country: "Country Select",
    field_type_phone: "Phone Number",
    field_type_weblink: "Website URL",
    countries: "Countries",
    languages: "Languages",
    common_sources: "Common Sources",
    gender_pronouns: "Gender Pronouns",
    field_must_be_valid_number: "{{field}} must be a valid number",
    field_must_be_valid_integer: "{{field}} must be a valid integer",
    field_must_be_valid_phone_number: "{{field}} must be a valid phone number",
    field_must_be_valid_url: "{{field}} must be a valid URL",
    save_changes: "Save changes",
    increment_value: "Increment value",
    decrement_value: "Decrement value",
    page_plural: "Pages",
    collection_plural: "Collections",
    event_plural: "Events",
    image_plural: "Images",
    access_forbidden_title: "You don't have access",
    access_forbidden_description: "This content is restricted. If you need access, sign in with an account that has the required role or contact the site owner.",
    custom_fields: "Custom Fields",
    user_details: "User Details",
    assets: "Dateien",
    asset: "Asset",
    upload: "Upload",
    path_prefix_hint: "Path prefix (without leading and trailing slashes)",
    remaining: "Remaining",
    no_assets_found: "No assets found",
    protected: "Protected",
    size: "Size",
    confirm_delete_selected_assets: "Are you sure you want to delete these {{count}} assets? This cannot be undone.",
    error_deleting_assets: "Error deleting assets: {{error}}",
    saving: "Saving...",
    
    // Analytics
    this_page: "This Page",
    site_total: "Site Total",
    views: "Views",
    relevance: "Relevance",
    peak: "Peak",
    no_data: "No data",
    no_peak_data: "Not enough data",
    last_n_days: "Last {{days}} days",
    analytics_n_days: "{{days}} days",
    analytics_visits: "Visits",
    analytics_trend: "vs. last month",
    analytics_sources: "Sources",
    analytics_campaigns: "Campaigns",
    analytics_exits: "Exits",
    analytics_exit_mail: "E-mail",
    referrer_direct: "Direct",
    referrer_internal: "Internal",
    referrer_external: "External",
    referrer_search: "Search",
    referrer_ai: "AI",
    referrer_social: "Social",
    
    // Canvas toolbars & entry selection
    move_up: "Move up",
    move_down: "Move down",
    move_left: "Move left",
    move_right: "Move right",
    add_block_after: "Add block after",
    add_block_before: "Add block before",
    remove_block: "Remove block",
    more_actions: "More actions",
    table_view: "Table view",
    grid_view: "Grid view",
    view_mode: "View mode",
    create_new: "Create new",
    field_visibility: "Visible fields",
    embeds: "Embeds",
    no_entries_selected: "No entries selected",
    add_selected_entries: "Add {{count}} entries",
    add_selected_images: "Add {{count}} images",
    add_selected_entry: "Add entry",
    browse_entries: "Browse entries",
    browse_entries_description: "Browse and select from all entries",
    browse_images: "Browse images",
    link_to_entry: "Link to entry",
    link_to_entries: "Link to {{count}} entries",
    select_entries_to_add: "Select entries to add",
    untitled: "Untitled",
    insert_new_entry: "Create entry",
    block_fields: "Block fields",
    entry_preview_fields: "Entry fields",
    entry_preview_input_placeholder: "Button or link text",
    clear_selection: "Clear selection",
    change_visibility: "Change visibility",
    count_entry_selected: "{{count}} entry selected",
    count_entries_selected: "{{count}} entries selected",

    // Stickers
    sticker_add: "Add sticker",
    sticker_edit: "Edit sticker",
    sticker_anchor: "Anchor",
    sticker_anchor_image: "Image",
    sticker_anchor_block: "Block",
    sticker_anchor_text: "Text fields",
    sticker_area: "Anchor point",
    sticker_size: "Size (px)",
    sticker_rotation: "Rotation (°)",
    sticker_offset: "Offset",
    sticker_label: "Label",
    sticker_label_placeholder: "e.g. Call now",
    sticker_link: "Link",
    sticker_replace_image: "Replace image",
    contents: "Contents",
    account_menu: "Account menu",
    alignment: "Alignment",
    basic_blocks: "Basic blocks",
    blocked: "Blocked",
    browse: "Browse contents",
    toggle_navigation: "Toggle navigation",
    open: "Open",
    read_by_user: "Read on",
    report: "Report",
    transparent: "Transparent",
    unknown: "Unknown",
    yes: "Yes",
    no: "No",
    future: "Later",
    play_video_for_title: "Play video {{title}}",
    pause_video_for_title: "Pause video {{title}}",
    unsaved_changes_warning: "You have unsaved changes. Close anyway?",
    error_deleting_entries: "Error deleting entries: {{error}}",
    error_updating_entries_visibility: "Error updating visibility: {{error}}",
    failed_to_create_collection: "Could not create the collection.",
    scale_factor: "Scale factor",
    select_control_surface: "Select surface",
    select_size: "Select size",
    select_weight: "Select weight",
    uppercase: "Uppercase",
    lowercase: "Lowercase",
    capitalize: "Capitalize",
    xxs: "XXS",
    xs: "XS",
    sm: "S",
    md: "M",
    lg: "L",
    xl: "XL",
    xxl: "XXL",
    xxxl: "XXXL",
    address: "Address",
    tel: "Phone",
    message: "Message",
    chat: "Chat",
    login: "Log in",
    stories: "Stories",
    news: "News",
    posts: "Posts",
    schedule: "Schedule",
    appointments: "Appointments",

    // CUSTOM_CODE_STARTS (PATCH_WORK)
    available_credits: "Remaining credit",
    available_quantity: "Available Quantity",
    capacity_can_only_be_increased_in_booking_window: "Only capacity can be edited (to prevent overbooking)",
    base_price: "Base price",
    book_as: "Book as",
    book_now: "Book now",
    booking_this_week: "Booking this week",
    booking_type: "Booking Type",
    bookings_for_month: "Bookings for {{month}}",
    bookings_this_week: "Bookings this week",
    bookings: "Bookings",
    booking: "Booking",
    change_resource: "Change resource",
    credits_used: "Credit used",
    current_year: "Current year",
    unavailable_for_booking: "This resource is not available for booking during the selected time period",
    daily: "Daily",
    desk: "Desk",
    discounted_price: "Member price",
    equipment_plural: "Equipment",
    equipment: "Equipment",
    fixed_desk_plural: "Fixed Desks",
    fixed_desk: "Fixed Desk",
    flex_desk_plural: "Flex Desks",
    flex_desk: "Flex Desk",
    free_using_credits: "Free",
    addon: "Addon",
    addon_plural: "Addons",
    half_hourly: "Half-hourly",
    max_price: "Max. Price",
    meeting_room_plural: "Meeting Rooms",
    meeting_room: "Meeting Room",
    membership_savings: "Membership savings",
    credits_in_month: "Credits for {{month}}",
    monthly: "Monthly",
    new_prices_from: "New prices from",
    next_year: "Next year",
    no_access: "No access",
    office_plural: "Offices",
    office: "Office",
    previous_year: "Previous year",
    price_breakdown: "Price breakdown",
    price_from: "From {{from}}",
    prices_and_capacities: "Prices and Capacities",
    pricing_invalid: "Some pricing data is incomplete. Please fill in all fields.",
    pricing_locked: "Once pricing is defined it cannot be changed.",
    pricing_method: "Pricing method",
    pricing_not_configured: "Pricing not configured",
    pricing_will_lock: "These pricings will be locked after saving and cannot be changed.",
    resource_label: "Resource",
    resource_label_plural: "Resources",
    resource_pricing_invalid: "Some pricing data is incomplete. Please fill in all fields.",
    resource: "Resource",
    resource_type: "Resource Type",
    save_pricing_failed: "Failed to save pricing. Please try again. If the issue persists contact support.",
    select_resource_type: "Select Resource Type",
    subscription: "Subscription", 
    this_month: "This Month",
    total_for_month: "Total for {{month}}",
    total_to_pay: "Total to pay",
    reserve_with_one_click: "Reserve with one click",
    reservations: "Reservations",
    reservations_for_authenticated_user: "My Reservations ({{name}})",
    reservations_for_current_user: "Reservations for <q>{{name}}</q>",
    how_to_book_as_representative: "You can book for yourself or your team members or company. Just click on your avatar to select the person or company you want to book for.",
    unavailable: "Unavailable",
    outside_business_hours: "Outside Business Hours",
    credit_allowance: "Credits in €",
    discount_percentage: "Discount in %",
    business_customer_vat_notice: "All prices are net prices and do not include statutory VAT; they are intended exclusively for entrepreneurs, self-employed (Section 14 of the German Civil Code (BGB)) and legal entities under public law.",
    click_to_book: "Select free slots one by one or drag across several. Nothing is booked until you confirm below.",
    click_to_cancel: "To cancel, select your booking and confirm below.",
    booking_sheet_label: "Confirm selection",
    booking_sheet_move: "Move panel",
    booking_sheet_toggle: "Show or hide details",
    booking_unit_slot: "slot",
    booking_unit_slots: "slots",
    booking_unit_slot_cancel: "slot to cancel",
    booking_unit_slots_cancel: "slots to cancel",
    booking_unit_desk: "desk",
    booking_unit_desks: "desks",
    booking_unit_desk_cancel: "desk to cancel",
    booking_unit_desks_cancel: "desks to cancel",
    booking_days: "{{count}} days",
    booking_storno: "{{count}} cancellation",
    booking_stornos: "{{count}} cancellations",
    booking_mini_selected: "selected",
    booking_mini_cancel: "selected to cancel",
    booking_mini_changes: "changes selected",
    booking_book: "Book",
    booking_cancel: "Cancel",
    booking_confirm: "Confirm",
    booking_book_count: "Book {{count}} {{unit}}",
    booking_cancel_count: "Cancel {{count}} {{unit}}",
    booking_book_and_cancel: "Book {{book}} · cancel {{cancel}}",
    booking_working_book: "Booking …",
    booking_working_cancel: "Cancelling …",
    booking_working_both: "Saving …",
    booking_receipt_booked: "Booked",
    booking_receipt_cancelled: "Cancelled",
    booking_receipt_changed: "Changes saved",
    booking_cancelled_suffix: "cancelled",
    booking_confirmation_email_to: "Confirmation by email to {{email}}",
    booking_invoice_to: "Invoice to {{name}}",
    booking_internal: "Internal (not billed)",
    booking_estimate: "Estimated",
    booking_estimate_credits: "after {{amount}} of credit",
    booking_estimate_day_max: "at most {{amount}} per day",
    booking_estimate_month_max: "{{price}} per day, at most {{max}} per month",
    booking_estimate_day_price: "{{price}} per day",
    booking_cap_reached: "(reached)",
    booking_cancellation_free: "Cancellation · free",
    booking_free_cancellation_until: "Free cancellation until {{time}}",
    booking_starts_soon_no_cancel: "Starts in less than {{minutes}} minutes: can't be cancelled once booked.",
    booking_starts_soon_short: "Starts soon: can't be cancelled",
    booking_clear_selection: "Clear selection",
    booking_done: "Done",
    booking_error_changed: "Availability changed in the meantime. The view has been updated.",
    booking_legend_selected: "Selected, not booked yet",
    booking_legend_selected_cancel: "Selected to cancel, not cancelled yet",
    booking_confirm_below: "Nothing is booked or cancelled until you confirm below.",
    booking_discard_selection: "Your selection has not been confirmed yet. Discard it?",
    cancel_free_until_minutes_before_booking: "Cancel free up to {{minutes}} minutes before your booking starts.",
    slot_symbols_explained: "Symbols explained",
    how_to_reserve_a_meeting_room: "How you can reserve a meeting room",
    how_to_book_a_desk: "How you can book a desk",
    previous_week: "Previous week",
    next_week: "Next week",
    days_with_bookings: "Days with bookings",
    click_any_date_to_book: "<b>Booking:</b> Click the plus icon on any date to book.",
    book_multiple_desks_per_team_member: "<b>Team booking:</b> You can book multiple desks at once for your team or your guests.",
    cancel_up_to_1_day_before_your_reservation: "<b>Cancellation:</b> You can cancel your reservation free of charge up to one day before.",
    active_subscriptions: "Active subscriptions",
    expired_subscriptions: "Expired subscriptions",
    selected_month_is_fully_booked: "The selected month is fully booked. Please select a different month.",
    start: "Start",
    end: "End",
    subscription_by: "Subscription by",
    book_new_subscription: "Book new subscription",
    cancellation_notice_period: "Cancellation notice period",
    cancel_subscription: "Cancel subscription",
    cancel_subscription_with_id: "Cancel #{{subscription}}",
    change_subscription_with_id: "Change subscription #{{subscription}}",
    select_end_date: "Select end date",
    select_start_date: "Select start date",
    at_end_of_month: "at the end of the month",
    months: "months",
    subscription_autorenewal: "Your subscription will be automatically renewed.",
    uncancel_subscription: "Withdraw cancellation",
    when_do_you_want_to_start: "When would you like to start?",
    half_hour: "30 min",
    no_end_date: "No end date.",
    new_subscription: "New Subscription",
    manage_subscriptions: "Manage Subscriptions",
    manage_bookings: "Manage Bookings",
    renews_automatically: "Renews automatically",
    meeting_room_confirmation_subject: "Meeting Room Booking Confirmation: {{date}}",
    meeting_room_reminder_subject: "Meeting Room Booking Reminder: {{date}}",
    meeting_room_confirmation_intro: "Your meeting room booking has been confirmed.",
    meeting_room_reminder_today: "You have {{count}} {{bookings}} for today ({{date}}):",
    meeting_room_reminder_tomorrow: "You have {{count}} {{bookings}} for tomorrow ({{date}}):",
    meeting_room_booking_date_and_time: "{{room_name}} <br>on {{booking_date}} <br>from <time datetime=\"{{start_time_iso}}\">{{start_time}}</time> to <time datetime=\"{{end_time_iso}}\">{{end_time}}</time> <em>({{hours}}h:{{minutes}}min)</em>",
    meeting_room_reminder_footer: "Please arrive on time and leave the room tidy for the next members. <br>Thank you!",
    alert_cancellation_time_limit: "This booking can no longer be cancelled: cancellations are only possible up to {{minutes}} minutes before it starts.",
    alert_insufficient_time_remaining: "This slot cannot be booked as there is less than 15 minutes remaining.",
    alert_slot_unavailable: "This slot is not available as someone else has already booked it.",
    alert_booking_not_authorized: "You are not authorized to make this booking.",
    alert_generic_error: "An error occurred while processing your request. Please try again.",
    daily_booking_new_confirmation_intro: "The following new {{resource_type}} bookings have just been confirmed:",
    daily_booking_monthly_overview_subject: "Confirmation of your {{resource_type}} bookings",
    daily_booking_entry: "{{date}}: {{count}}× {{resource}}",
    daily_booking_footer: "We're looking forward to seeing you!",
    booking_cancellation_subject: "Cancellation confirmed",
    booking_cancellation_intro: "The following bookings have been cancelled:",
    booking_cancellation_room_entry: "{{date}}: {{room_name}}, {{start_time}}–{{end_time}}",
    booking_cancellation_footer: "Cancelled bookings are not charged.",
    daily_booking_reminder_subject: "{{resource_type}} Booking Reminder: {{date}}",
    daily_booking_reminder_intro: "Just a reminder about your {{resource_type}} bookings for tomorrow ({{date}}):",
    daily_booking_calendar_for_month: "{{resource_type}} Booking Calendar for {{month}}",
    subscription_confirmation_subject: "Subscription Confirmation: {{name}}",
    subscription_confirmation_intro: "You have successfully booked the subscription for <strong>{{resource_name}}</strong>:",
    subscription_booking_details: "{{resource_name}} starting {{start_date}}",
    subscription_confirmation_footer: "Thank you for your booking!",
    error_not_authorized: "You are not authorized to perform this action.",
    error_subscription_not_available_for_start_period: "This subscription is no longer available for the selected start period.",
    error_database_error: "An error occurred while processing your request. Please try again.",
    error_unknown: "An unexpected error occurred. Please try again later.",
    subscription_booked_successfully: "Subscription <strong>{{resource_name}}</strong> booked successfully for <strong>{{user_name}}</strong>",
    alert_booked_by_me_in_past: "You have already booked this slot in the past.",
    subscription_booked_for: "This subscription was booked for and will be billed by <strong>{{name}}</strong>.",
    days: "Days",
    how_are_you_planning_to_use_website: "How are you planning to use {{name}}?",
    sign_up_for_personal_use_title: "For personal use",
    sign_up_for_personal_use_description: "Book in your own name and on your own account (e.g. freelancer, self-employed)?",
    sign_up_for_personal_use_next_step_info: "Please provide your billing address and payment method in the next step.",
    sign_up_for_joining_team_title: "Join my team",
    sign_up_for_joining_team_description: "You are a member of a team and want to book on behalf of your company?",
    sign_up_for_joining_team_next_step_info: "After completing the sign up, contact your company's representative and ask them to give your account <span class='-bold'>{{email}}</span> team access.",
    sign_up_for_new_business_title: "New company",
    sign_up_for_new_business_description: "Create a new company account and invite your team members to join.",
    sign_up_for_new_business_next_step_info: "Please provide your billing address and payment method in the next step, so your team can book on your company account.",
    complete_sign_up: "Complete sign up",
    continue_to_stripe: "Continue",
    billing: "Billing",
    city: "City",
    country: "Country",
    address_line1: "Address Line 1",
    address_line2: "Address Line 2",
    postal_code: "Postal Code",
    payment_method_set: "Payment Method set",
    billing_portal: "Billing Portal",
    no_payment_method_set_required_for_booking: "No payment method set. Required for booking!",
    billing_address_not_set: "Billing address incomplete. A complete address is required for invoicing.",
    billing_address: "Billing address",
    change_billing_address: "Change billing address", 
    manage_payment_method: "Manage payment method",
    cancelled_at: "Cancelled at",
    book_rooms_and_times: "Rooms & Times",
    keep_track_of_your_bookings: "Keep track of your bookings.",
    book_with_one_click: "Book with one click.",
    add_payment_details: "Add payment details",
    add_billing_address: "Add billing address",
    need_help_with_billing_title: "Need help with billing?",
    need_help_with_billing_description: "We're here to help you with any billing questions or issues you may have.",
    contact_support: "Contact support",
    book_and_pay_now: "Book and pay now",
    plus_vat: "plus VAT",
    confirm_your_booking: "Confirm your booking",
    booking_for: "Booking for",
    booking_on_invoice_of: "Booking on invoice of",
    on_count_of_day: "on {{count}} day",
    on_count_of_days: "on {{count}} days",
    subscriptions: "Subscriptions",
    fully_booked: "Fully booked",
    add_missing_payment_details: 'To book, first add a <a class="underline" href="{{href}}">payment method</a>.',
    add_missing_billing_address: 'To book, first add a <a class="underline" href="{{href}}">billing address</a>.',
    add_missing_payment_details_or_switch_account: 'To book, first add a <a class="underline" href="{{href}}">payment method</a> or switch to your team / company account.',
    book_on_behalf_of_company_team_member_hint: 'If you want to book on behalf of your company, please contact your company\'s representative and ask them to add your email <span class="text-3">{{email}}</span> to the company account for team access.',
    pricing_and_capacity: "Pricing & Capacity",
    contact_us_for_custom_requests: "Contact us for custom requests",
    login_and_book: "Login & Book",
    no_fitting_month_found: "No fitting month found?",
    new_subscription_booked: "New subscription \"{{resource_name}}\" booked by {{customer_name}}",
    view_subscriptions: "View subscriptions",
    custom_price: "Custom price",
    booked_by_user_details: "Booked by {{name}} <br />{{email}}",
    new_meeting_room_booking_email_subject_admin: "New meeting room booking by {{user_name}} ({{user_email}}) on {{date}}",
    new_daily_booking_email_subject_admin: "New daily booking for {{resource_name}} by {{user_name}} ({{user_email}})",
    booking_cancellation_subject_admin: "Cancellation by {{user_name}} ({{user_email}})",
    booking_cancellation_admin_intro: "The following bookings have just been cancelled:",
    bookings_for_day: "Bookings for {{day}}",
    no_bookings_for_this_day: "No bookings for this day",
    add_internal_booking_notes: "Add internal notes about bookings (only visible to admins)",
    last_update_by: "Last updated by {{name}}",
    offices_desks_and_more: "Offices, desks and more",
    bookings_on: "Bookings on",
    no_bookings_on_day: "No bookings on {{date}}",
    locks_tooltip: "Enter the lock identifiers for the access points of the resource. These must be precisely matching the identifiers used by the access control system.",
    add_lock: "Add lock",
    locks: "Locks",
    lock_id: "Lock ID",
    room_id: "Room ID",
    no_lock_selected: "No lock selected",
    no_lock_selected_hint: "Select a Loxone lock.",
    unknown_room: "Unknown room",
    unknown_lock: "Unknown lock",
    select_lock: "Select lock",
    sync_loxone_locks: "Sync Loxone locks",
    syncing_loxone_locks: "Syncing Loxone locks...",
    loxone_lock_sync_ready: "Lock catalog synced.",
    loxone_lock_sync_fallback_active: "Live sync failed, using local structure file.",
    loxone_lock_sync_cached_data: "Live sync failed, using cached data.",
    loxone_lock_catalog_load_failed: "Failed to load Loxone lock catalog.",
    loxone_lock_unknown_warning: "This lock does not exist in the current Loxone catalog.",
    loxone_lock_assigned_elsewhere: "Also used by another resource.",
    loxone_lock_assigned_elsewhere_to: "Also used by: {{resources}}.",
    loxone_lock_assigned_elsewhere_short: "Also used by another resource.",
    loxone_lock_assigned_elsewhere_to_short: "Also used by: {{resources}}",
    loxone_lock_reassignment_notice: "Locks can be shared across multiple resources.",
    room_id_not_set: "No room ID set",
    lock_id_not_set: "No lock ID set",
    access_code: "Access code",
    access_code_generation_failed: "Access code generation failed. Please contact support.",
    meeting_room_booking_admin_intro: "The following new meeting room bookings have just been confirmed:",
    max_individual_daily_bookings_per_day: "Maximum bookings per day",
    max_individual_daily_bookings_per_day_tooltip: "Maximum number of bookings an individual user can make per day. Leave empty for unlimited.",
    max_individual_daily_bookings_per_month: "Maximum bookings per month",
    max_individual_daily_bookings_per_month_tooltip: "Maximum number of bookings an individual user can make per month. Leave empty for unlimited.",
    max_individual_daily_bookings_per_day_reached: "You have reached the daily booking limit of {{max}}.",
    max_individual_daily_bookings_per_month_reached: "You have reached the monthly booking limit of {{max}}.",
    open_day: "Open Day",
    booking_count: "Booking count",
    cancellation_notice: "Term: monthly, minimum term: {{months}} {{unit}}",
    credit_allowance_for_meeting_room: "Credits for meeting room bookings",
    discount_for_meeting_room: "Discount for meeting room bookings",
    subscriber_benefits: "Your benefits as a subscriber",
    welcome_name: "Welcome, {{name}}",
    your_meeting_is_in_progress: "Your booking is in progress. Use your code from your booking email to enter the meeting room.",
    your_meeting_starts_soon: "Your booking starts soon. Use your code from your booking email to enter the meeting room.",
    meeting_room_available: "Meeting room available",
    book_via_app: "Book via our app",
    good_to_know: "Good to know",
    billing_log: "Billing Log",
    invoice_generation_status: "Invoice Generation Status",
    error_detected_requires_manual_intervention: "Error detected - requires manual intervention",
    error_details: "Error Details",
    retry_invoice_generation: "Retry Invoice Generation",
    unbilled_bookings_pending: "Pending",
    meeting_room_bookings: "Meeting Rooms",
    daily_bookings_flex_desks: "Flex Desks",
    recent_invoices: "Invoices",
    billed_meeting_room_days: "Meeting Rooms (billed)",
    billed_daily_booking_months: "Flex Desks (billed)",
    period: "Period",
    slots: "Slots",
    stripe_invoice: "Stripe Invoice",
    price_basis: "Price Basis",
    invoice: "Invoice",
    notice_terms_and_conditions: "By proceeding with this booking, you agree to the <a href='{{terms_and_conditions}}' target='_blank' class='underline'>Terms and Conditions</a>.",
    // CUSTOM_CODE_ENDS (PATCH_WORK)
  }
}
